var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademy20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eRgiJqp653L1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 380",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "810eff8522fd4276bbdca2f28208c445",
    "export-id": "672e914371474005b9d71b283cbcf85a",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L63-fill",
    x1: 1781.95,
    y1: 1363.14,
    x2: 1790.154,
    y2: 1363.14,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L63-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L63-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L81-fill",
    x1: 1776.93,
    y1: 1356.36,
    x2: 1786.113,
    y2: 1356.36,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L81-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L81-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L115-fill",
    x1: 1758.72,
    y1: 1242.34,
    x2: 1783.314,
    y2: 1242.34,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L115-fill-0",
    offset: "10.4%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L115-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L119-fill",
    x1: 1780.48,
    y1: 1255.11,
    x2: 1782.09,
    y2: 1255.11,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L119-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L119-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L120-fill",
    x1: 1768.74,
    y1: 1252.43,
    x2: 1771.072,
    y2: 1252.43,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L120-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L120-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L121-fill",
    x1: 1772.86,
    y1: 1268.79,
    x2: 1773.898,
    y2: 1268.79,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L121-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L121-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L122-fill",
    x1: 1762.3,
    y1: 1270.38,
    x2: 1770.485,
    y2: 1270.38,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L122-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L122-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L123-fill",
    x1: 1771.54,
    y1: 1271.39,
    x2: 1774.767,
    y2: 1271.39,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L123-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L123-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L139-fill",
    x1: 1741.37,
    y1: 1258.78,
    x2: 1757.128,
    y2: 1258.78,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L139-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L139-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L140-fill",
    x1: 1748.13,
    y1: 1267.96,
    x2: 1750.744,
    y2: 1267.96,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L140-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L140-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L141-fill",
    x1: 1746.62,
    y1: 1267.07,
    x2: 1749.477,
    y2: 1267.07,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L141-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L141-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L142-fill",
    x1: 1744.36,
    y1: 1264.9,
    x2: 1748.553,
    y2: 1264.9,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L142-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L142-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L143-fill",
    x1: 1742.33,
    y1: 1264.09,
    x2: 1743.611,
    y2: 1264.09,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L143-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L143-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L144-fill",
    x1: 1742.28,
    y1: 1269,
    x2: 1743.033,
    y2: 1269,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L144-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L144-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L145-fill",
    x1: 1743.42,
    y1: 1270.03,
    x2: 1744.239,
    y2: 1270.03,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L145-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L145-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L146-fill",
    x1: 1744.91,
    y1: 1271.2,
    x2: 1745.775,
    y2: 1271.2,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L146-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L146-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L151-fill",
    x1: 1734.31,
    y1: 1389.02,
    x2: 1752.495,
    y2: 1389.02,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L151-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L151-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L156-fill",
    x1: 1732.71,
    y1: 1342.34,
    x2: 1749.918,
    y2: 1342.34,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L156-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L156-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L173-fill",
    x1: 1780.52,
    y1: 1300.81,
    x2: 1793.226,
    y2: 1300.81,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L173-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L173-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L174-fill",
    x1: 1789.83,
    y1: 1309.23,
    x2: 1792.514,
    y2: 1309.23,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L174-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L174-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L176-fill",
    x1: 1654.79,
    y1: 1259.82,
    x2: 1659.023,
    y2: 1247.628,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L176-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L176-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L177-fill",
    x1: 1720.43,
    y1: 1256.97,
    x2: 1696.528,
    y2: 1300.292,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L177-fill-0",
    offset: "10.4%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L177-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L179-fill",
    x1: 1634.09,
    y1: 1258.43,
    x2: 1658.501,
    y2: 1223.754,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L179-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L179-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L181-fill",
    x1: 1662.01,
    y1: 1262.63,
    x2: 1667.489,
    y2: 1252.486,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L181-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L181-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L184-fill",
    x1: 1674.15,
    y1: 1259.2,
    x2: 1678.664,
    y2: 1250.842,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L184-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L184-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L187-fill",
    x1: 1674.36,
    y1: 1268.57,
    x2: 1679.26,
    y2: 1259.486,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L187-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L187-fill-1",
    offset: "85.6%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L188-fill",
    x1: 1691.74,
    y1: 1265.31,
    x2: 1682.054,
    y2: 1283.917,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L188-fill-0",
    offset: "32.5%",
    stopColor: "#d15050"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L188-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L189-fill",
    x1: 1652.99,
    y1: 1254.54,
    x2: 1655.993,
    y2: 1244.242,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L189-fill-0",
    offset: "12.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L189-fill-1",
    offset: "52.9%",
    stopColor: "#ed956e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L191-fill",
    x1: 1689.08,
    y1: 1246.98,
    x2: 1679.162,
    y2: 1257.94,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L191-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L191-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L192-fill",
    x1: 1675.69,
    y1: 1247.95,
    x2: 1670.161,
    y2: 1253.598,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L192-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L192-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L203-fill",
    x1: 1704.23,
    y1: 1316.71,
    x2: 1706.519,
    y2: 1326.642,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L203-fill-0",
    offset: "12.6%",
    stopColor: "#056657"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L203-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L204-fill",
    x1: 1590.33,
    y1: 1354.95,
    x2: 1680.114,
    y2: 1242.511,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L204-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L204-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L205-fill",
    x1: 1593.04,
    y1: 1321.35,
    x2: 1695.308,
    y2: 1164.181,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L205-fill-0",
    offset: "17.4%",
    stopColor: "#b5a3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L205-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L205-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L206-fill",
    x1: 1629.99,
    y1: 1322.7,
    x2: 1721.091,
    y2: 1188.155,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L206-fill-0",
    offset: "17.4%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L206-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L206-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L207-fill",
    x1: 1654.38,
    y1: 1274.28,
    x2: 1705.566,
    y2: 1288.494,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L207-fill-0",
    offset: "17.4%",
    stopColor: "#b5a3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L207-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L207-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L208-fill",
    x1: 1636.96,
    y1: 1283.93,
    x2: 1689.662,
    y2: 1213.662,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L208-fill-0",
    offset: "17.4%",
    stopColor: "#b5a3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L208-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L208-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L210-fill",
    x1: 1674.42,
    y1: 1252.34,
    x2: 1671.702,
    y2: 1257.266,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L210-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L210-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L212-fill",
    x1: 1675.27,
    y1: 1263.88,
    x2: 1673.984,
    y2: 1265.477,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L212-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L212-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L220-fill",
    x1: 1685.62,
    y1: 1252.44,
    x2: 1683.334,
    y2: 1256.583,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L220-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L220-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L225-fill",
    x1: 1692.6,
    y1: 1284.53,
    x2: 1677.491,
    y2: 1306.698,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L225-fill-0",
    offset: "15.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L225-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L226-fill",
    x1: 1680.24,
    y1: 1278.5,
    x2: 1668.143,
    y2: 1288.884,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L226-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L226-fill-1",
    offset: "92.1%",
    stopColor: "#f05960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L227-fill",
    x1: 1656.73,
    y1: 1259.99,
    x2: 1670.999,
    y2: 1277.355,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L227-fill-0",
    offset: "12.6%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L227-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L228-fill",
    x1: 1656.9,
    y1: 1256.43,
    x2: 1662.583,
    y2: 1250.466,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L228-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L228-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L231-fill",
    x1: 1669.15,
    y1: 1233.45,
    x2: 1681.639,
    y2: 1232.975,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L231-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L231-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L235-fill",
    x1: 1692.51,
    y1: 1319.43,
    x2: 1643.864,
    y2: 1318.1,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L235-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L235-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L236-fill",
    x1: 1692.42,
    y1: 1322.64,
    x2: 1643.774,
    y2: 1321.31,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L236-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L236-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L243-fill",
    x1: 1698.1,
    y1: 1317.8,
    x2: 1716.097,
    y2: 1317.115,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L243-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L243-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L244-fill",
    x1: 1732.36,
    y1: 1308.34,
    x2: 1691.182,
    y2: 1344.486,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L244-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L244-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L246-fill",
    x1: 1719.59,
    y1: 1323.94,
    x2: 1712.148,
    y2: 1324.223,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L246-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L246-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L247-fill",
    x1: 1721.23,
    y1: 1322.93,
    x2: 1709.888,
    y2: 1323.361,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L247-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L247-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L248-fill",
    x1: 1720.04,
    y1: 1329.87,
    x2: 1710.678,
    y2: 1325.118,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L248-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L248-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L249-fill",
    x1: 1715.41,
    y1: 1327.15,
    x2: 1710.041,
    y2: 1327.354,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L249-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L249-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L255-fill",
    x1: 1718.26,
    y1: 1323.8,
    x2: 1711.865,
    y2: 1324.043,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L255-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L255-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L256-fill",
    x1: 1714.64,
    y1: 1332.51,
    x2: 1715.064,
    y2: 1323.634,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L256-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L256-fill-1",
    offset: "63.7%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L256-fill-2",
    offset: "94.4%",
    stopColor: "#c93d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L257-fill",
    x1: 1697.87,
    y1: 1317.43,
    x2: 1706.864,
    y2: 1317.088,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L257-fill-0",
    offset: "1.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L257-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L260-fill",
    x1: 1734.36,
    y1: 1323.86,
    x2: 1674.425,
    y2: 1321.531,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L260-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L260-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L261-fill",
    x1: 1734.25,
    y1: 1326.52,
    x2: 1674.315,
    y2: 1324.191,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L261-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L261-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L263-fill",
    x1: 1675.28,
    y1: 1271.69,
    x2: 1714.474,
    y2: 1375.133,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L263-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L263-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L264-fill",
    x1: 1727.56,
    y1: 1278.47,
    x2: 1697.912,
    y2: 1310.295,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L264-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L264-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L265-fill",
    x1: 1756.87,
    y1: 1318.77,
    x2: 1698.108,
    y2: 1283.498,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L265-fill-0",
    offset: "0%",
    stopColor: "#faa24b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L265-fill-1",
    offset: "100%",
    stopColor: "#ffce94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L266-fill",
    x1: 1748.14,
    y1: 1383.97,
    x2: 1770.718,
    y2: 1318.989,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L266-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L266-fill-1",
    offset: "63.7%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L266-fill-2",
    offset: "94.4%",
    stopColor: "#c93d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L267-fill",
    x1: 1722.15,
    y1: 1320.81,
    x2: 1728.582,
    y2: 1317.9,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L267-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L267-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L269-fill",
    x1: 1723.44,
    y1: 1354.69,
    x2: 1744.989,
    y2: 1354.69,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L269-fill-0",
    offset: "0%",
    stopColor: "#894a3f"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L269-fill-1",
    offset: "100%",
    stopColor: "#be695b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L277-fill",
    x1: 1793.92,
    y1: 1326.61,
    x2: 1748.916,
    y2: 1323.062,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L277-fill-0",
    offset: "42.4%",
    stopColor: "#009465"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L277-fill-1",
    offset: "99.9%",
    stopColor: "#006a62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L280-fill",
    x1: 1807.9,
    y1: 1266.61,
    x2: 1778.252,
    y2: 1298.435,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L280-fill-0",
    offset: "0%",
    stopColor: "#009465"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L280-fill-1",
    offset: "11%",
    stopColor: "#008a64"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L280-fill-2",
    offset: "25%",
    stopColor: "#048e83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L281-fill",
    x1: 1837.2,
    y1: 1306.92,
    x2: 1778.438,
    y2: 1271.648,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L281-fill-0",
    offset: "0%",
    stopColor: "#82cba5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L281-fill-1",
    offset: "100%",
    stopColor: "#76c9b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L282-fill",
    x1: 1828.48,
    y1: 1372.12,
    x2: 1851.058,
    y2: 1307.139,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L282-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L282-fill-1",
    offset: "63.7%",
    stopColor: "#71c8b4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L282-fill-2",
    offset: "94.4%",
    stopColor: "#006b40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L283-fill",
    x1: 1802.49,
    y1: 1308.95,
    x2: 1808.922,
    y2: 1306.04,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L283-fill-0",
    offset: "42.4%",
    stopColor: "#009465"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L283-fill-1",
    offset: "99.9%",
    stopColor: "#006a62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L285-fill",
    x1: 1762.98,
    y1: 1257.42,
    x2: 1786.191,
    y2: 1255.914,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L285-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L285-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L301-fill",
    x1: 1918.78,
    y1: 1234.69,
    x2: 1972.397,
    y2: 1234.69,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L301-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L301-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L302-fill",
    x1: 1924.93,
    y1: 1236.01,
    x2: 1931.899,
    y2: 1236.01,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L302-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L302-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L309-fill",
    x1: 2027.48,
    y1: 1265.52,
    x2: 2020.799,
    y2: 1271.294,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L309-fill-0",
    offset: "0%",
    stopColor: "#f9b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L309-fill-1",
    offset: "100%",
    stopColor: "#e58f8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L310-fill",
    x1: 1980.38,
    y1: 1231.06,
    x2: 1989.257,
    y2: 1245.134,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L310-fill-0",
    offset: "0%",
    stopColor: "#f9b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L310-fill-1",
    offset: "100%",
    stopColor: "#e58f8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L311-fill",
    x1: 2013.17,
    y1: 1274.81,
    x2: 1968.389,
    y2: 1298.475,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L311-fill-0",
    offset: "0%",
    stopColor: "#f9b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L311-fill-1",
    offset: "100%",
    stopColor: "#e58f8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L315-fill",
    x1: 1981.65,
    y1: 1360.96,
    x2: 1988.084,
    y2: 1360.96,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L315-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L315-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L316-fill",
    x1: 1989.83,
    y1: 1375.65,
    x2: 1998.881,
    y2: 1375.65,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L316-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L316-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L339-fill",
    x1: 1996.3,
    y1: 1263.43,
    x2: 2011.514,
    y2: 1263.43,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L339-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L339-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L340-fill",
    x1: 1996.81,
    y1: 1274.73,
    x2: 2003.524,
    y2: 1274.73,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L340-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L340-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L341-fill",
    x1: 1999.41,
    y1: 1276.14,
    x2: 2002.827,
    y2: 1276.14,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L341-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L341-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L345-fill",
    x1: 1973.33,
    y1: 1214.39,
    x2: 1992.313,
    y2: 1214.39,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L345-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L345-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L352-fill",
    x1: 1976.06,
    y1: 1225.65,
    x2: 1978.215,
    y2: 1225.65,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L352-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L352-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L354-fill",
    x1: 1980.29,
    y1: 1231.48,
    x2: 1987.509,
    y2: 1231.48,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L354-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L354-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L356-fill",
    x1: 1760.78,
    y1: 1268.85,
    x2: 1771.459,
    y2: 1268.85,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L356-fill-0",
    offset: "5.6%",
    stopColor: "rgba(151,153,156,0.6)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L356-fill-1",
    offset: "77.1%",
    stopColor: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L357-fill",
    x1: 1931.67,
    y1: 1246.3,
    x2: 1966.682,
    y2: 1246.3,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L357-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L357-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eRgiJqp653L358-fill",
    x1: 1978.29,
    y1: 1213.28,
    x2: 1991.767,
    y2: 1213.28,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L358-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eRgiJqp653L358-fill-1",
    offset: "100%",
    stopColor: "#a96f65"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2 0 0 1.2-1966.925245-1380.346619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eRgiJqp653L5",
    transform: "matrix(1.241563 0 0 0.979648-513.577521-233.999575)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1952.4,1152.1v61.7v61.8c0,2.2-1.3,4.1-3.3,5.5s-4.8,2.2-7.8,2.2h-92.6-92.6c-3.1,0-5.8-.8-7.9-2.2-2-1.4-3.2-3.3-3.2-5.5v-61.8-61.7h103.7h103.7Z",
    fill: "#424649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1952.4,1143.5v4.3v4.3h-103.7-103.7v-4.3-4.3c0-2.2,1.4-4.9,3.4-6.2c2-1.4,4.6-1.5,7.7-1.5h92.6h92.6c3,0,5.7,0,7.7,1.4c2.1,1.4,3.4,4.1,3.4,6.3Z",
    fill: "#2f3335"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1761.3,1143.8c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.7,1143.8c0,1.8-1.5,3.2-3.2,3.2-1.8,0-3.3-1.4-3.3-3.2s1.5-3.2,3.3-3.2c1.7,0,3.2,1.4,3.2,3.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.1,1143.8c0,1.8-1.5,3.2-3.3,3.2-1.7,0-3.2-1.4-3.2-3.2s1.5-3.2,3.2-3.2c1.8,0,3.3,1.4,3.3,3.2Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1802.9,1188.1h-11-10.9v-.6-.6h10.9h11v.6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.6,1203.4h-11-10.9v-.6-.7h10.9h11v.7.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1819.9,1203.4h-7.6-7.6v-.6-.7h7.6h7.6v.7.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815.2,1188.1h-3.6-3.6v-.6-.6h3.6h3.6v.6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783.1,1173.8h-3.6-3.6v-.7-.6h3.6h3.6v.6.7Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.9,1173.9h-3-3.1v-.6-.6h3.1h3v.6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781,1211.3h-3.4-3.3v-.6-.6h3.3h3.4v.6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781,1239h-3.4-3.3v-.6-.6h3.3h3.4v.6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860.1,1204h-3.1-3v-.6-.6h3h3.1v.6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1835.8,1187.9h-8.9-8.8v-.5-.5h8.8h8.9v.5.5Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1794.3,1224.7h-10.4-10.4v-.6-.5h10.4h10.4v.5.6Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.5,1215.7v13.8v13.8h-.6-.5v-13.8-13.8h.5.6Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.7,1250.6h-9.4-9.3v-.6-.5h9.3h9.4v.5.6Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1801.8,1250.6h-5-5v-.6-.5h5h5v.5.6Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.8,1256.9h-5-5v-.5-.5h5h5v.5.5Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.7,1195.7h-10.9-11v-.6-.6h11h10.9v.6.6Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815,1195.7h-3.6-3.6v-.6-.6h3.6h3.6v.6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.8,1257h-6.1-6.2v-.6-.6h6.2h6.1v.6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1829.3,1204h-2.7-2.7v-.6-.6h2.7h2.7v.6.6Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1835.6,1195.6h-8.8-8.9v-.6-.5h8.9h8.8v.5.6Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.8,1224.7h-4.4-4.4v-.6-.5h4.4h4.4v.5.6Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1818.1,1224.7h-3.3-3.2v-.6-.5h3.2h3.3v.5.6Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811.5,1256.9h-3.3-3.3v-.5-.5h3.3h3.3v.5.5Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.2,1256.9h-3.3-3.2v-.5-.5h3.2h3.3v.5.5Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1829.5,1224.7h-3.3-3.2v-.6-.5h3.2h3.3v.5.6Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1837.3,1224.7h-3.3-3.3v-.6-.5h3.3h3.3v.5.6Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.3,1224.7h-3.2-3.3v-.6-.5h3.3h3.2v.5.6Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.5,1203.9h-9.7-9.6v-.5-.6h9.6h9.7v.6.5Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.3,1232.2h-11-10.9v-.6-.7h10.9h11v.7.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1823.3,1232.2h-9.4-9.4v-.6-.7h9.4h9.4v.7.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850.4,1232.7h-10.5-10.4v-.5-.5h10.4h10.5v.5.5Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.2,1232.7h-10.5-10.5v-.5-.5h10.5h10.5v.5.5Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843.2,1256.9h-9-9.1v-.5-.5h9.1h9v.5.5Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1863.7,1256.9h-9.1-9v-.5-.5h9h9.1v.5.5Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.4,1232.7h-10.5-10.5v-.5-.5h10.5h10.5v.5.5Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1879.3,1256.9h-6.7-6.7v-.5-.5h6.7h6.7v.5.5Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1893.2,1256.9h-6.3-6.2v-.5-.5h6.2h6.3v.5.5Z",
    fill: "#f29f05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eRgiJqp653L50",
    transform: "translate(-456.2 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1659.5,1440.2q-.9.7-1.6,1.7c4.3,3.3,10,3.8,15.3,4c6.5.2,14.7.4,20.5-3-1-3.1-5.1-5.3-7.7-7-3.1-1.9-7-3.8-10.7-3.3-2.3.3-4.5,1.8-6.6,2.7-3.1,1.4-6.6,2.6-9.2,4.9Z",
    fill: "#ebe0d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.4,1420.7q-.4-10.7-.8-21.4c0-.8-2.2-1.1-3.5-.8q0-.7.1-1.3c.1-1.5-4-1.1-4.6-.1s.2,5,.3,6.3q.1,3.6.2,7.2c.2,7.7-.1,15.7.9,23.4.1.6.3,1.2.7,1.6.3.2.7.3,1.1.3c1,.3,1.9.7,2.9.9c1,.1,2.1-.1,2.7-.9c1-1.3.3-4.8.3-6.5c0-2.9-.2-5.8-.3-8.7Z",
    fill: "#ddcbbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656,1400c12,4.6,25.1,6.1,37.8,4.2c1.8-.3,3.6-.6,5-1.8c1.3-1.2,1.9-2.9,2.5-4.6c1.2-3.6,2.2-8.3-.7-10.8-1.2-1-2.8-1.4-4.3-1.8q-6.8-1.5-13.6-2.6c-9.6-1.5-20.4-2.3-29.6,1.5-9,3.9-4.5,13,2.9,15.9Z",
    fill: "#ebe0d7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1646.7,1360.1c1.1-8.3,2.5-17.2,6.5-24.5c4.3-7.8,13.3-13.5,21.7-13.3c7.3.2,14.4,4.2,19.1,10.4c4.9,6.3,6.1,15.1,7.2,23.4c1.1,8.5.4,16.4,0,24.9c0,1-.1,1.9-.5,2.8-1.3,2.3-4.3,1.3-6.3,1.3-3,0-6-.1-9-.2-7.1-.4-14.2-.6-21.3-.5-5.5.2-17.1,2.2-17.8-6.2-.5-6-.3-12.1.4-18.1Z",
    fill: "#ddcbbc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1749.1,1423.4q-.8.8-1.6,1.7c4.3,3.3,10,3.9,15.3,4.1c6.6.2,14.7.4,20.5-3.1-1-3.1-5.1-5.3-7.7-7-3.1-1.9-6.9-3.8-10.7-3.3-2.3.3-4.5,1.8-6.6,2.7-3.1,1.4-6.6,2.6-9.2,4.9Z",
    fill: "#ddcbbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770,1403.9q-.4-10.7-.8-21.4c0-.9-2.2-1.2-3.5-.9q0-.6.1-1.2c.1-1.5-4-1.1-4.6-.2-.6,1,.2,5.1.3,6.4q.1,3.6.2,7.2c.2,7.7-.1,15.7,1,23.4c0,.6.2,1.2.7,1.6.3.2.6.3,1,.3c1,.3,1.9.7,2.9.9c1,.1,2.1-.1,2.7-.9c1.1-1.3.3-4.8.3-6.5.1-2.9-.2-5.8-.3-8.7Z",
    fill: "#ddcbbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.6,1383.1c12,4.6,25.2,6.1,37.8,4.2c1.8-.2,3.6-.6,5-1.8c1.3-1.1,1.9-2.9,2.5-4.6c1.2-3.6,2.2-8.2-.7-10.8-1.2-1-2.7-1.4-4.3-1.7q-6.7-1.6-13.6-2.7c-9.6-1.5-20.4-2.3-29.5,1.6-9.1,3.8-4.6,12.9,2.8,15.8Z",
    fill: "#ddcbbc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1790.1,1420.2q-.2-1.6-.3-3.3-.2-2.2-.3-4.4.2-.9.3-1.8c.2-.8.3-1.5,0-2.2-.6-1.5-2.4-1.5-3.7-1.2-1.4.4-2.6,1.3-3.3,2.6-.9,1.4-.9,3.2-.8,4.9q.1,2.8.3,5.7c.1.7.2,1.4.7,1.8.7.5,1.5.3,2.2.3c1.4.2,3.1,1.2,4.4,0c.6-.6.6-1.5.5-2.4Z",
    fill: "url(#eRgiJqp653L63-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1798.3,1429.5q-.6-1.1-1.4-2.2c-.7-1-1.5-1.9-2.4-2.8q-.3-.3-.5-.7c-.7-1-1.3-2-2-3-.7-.9-1.3-2-2.4-2.5-.9-.5-2.2-.5-3,.1-.5.3-.7.7-.9,1.2-.3.6-.9,1.2-1.6.9-.7-.4-1.2-.9-2-1-1.5-.3-2.1,1.2-2.2,2.4-.2,1.7-.1,3.4.2,5.1.1.9.2,1.7.4,2.5.1.8.5,1.4,1.1,1.8.5.5,1.2.9,1.9,1.3q1,.5,2.2.8c.8.1,1.7.2,2.5.2q1.3.1,2.7.2q2.7.2,5.4.3c.7,0,1.3-.1,1.8-.6.5-.4.7-1.1.8-1.7c0-.8-.2-1.6-.6-2.3Z",
    fill: "#d8b99c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.5,1429.6c-1.1,0-2.2-.5-3-1.9c0-.2,0-.4.2-.5.1-.1.3,0,.4.1c1.4,2.5,3.8,1.5,6.5.4c2.2-.9,4.5-1.8,6.4-.9.2.1.2.3.1.4c0,.2-.2.3-.4.2-1.6-.8-3.8.1-5.8.9-1.5.6-3,1.3-4.4,1.3Z",
    fill: "#f1d6b3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1795.2,1378.7c-.1-2-.3-4.2-1.9-5.7q-.1-.1-.3-.2q0-.3-.1-.5-.3-1.6-.8-3.3c-.5-2-1.1-4.1-2.1-5.9-1.8-3.1-5-5.1-8.2-6.5q-1.2-.5-2.4-.9c-.8-.8-1.6-1.5-2.5-2.1q-1.6-1.1-3.6-1.3c-1.4-.1-2.7,0-4.1.2q-2.1.2-4.2.6c-5.1.9-10.2,2.7-14.4,5.9-1.1.9-2.2,1.8-3.1,2.8q-.8.9-1.5,1.9c-.1.1-.2.3-.3.5-1.1,2.1-1.6,4.7-.8,7c.4,1.5,1.4,2.8,2.4,3.9q1.5,1.6,3.3,2.8c5.2,3.5,11.6,4.5,17.8,5.1c1.8.2,3.6.3,5.4.5.9.2,1.8.4,2.6.9c1.5,4,1.3,8.2,1.5,12.3q.1,1.5.3,3.1c.1.5.1,1.1.6,1.2.4.2.9,0,1.3-.1q1.5-.2,3,.2.3,0,.6.1.5,3.6.2,7.1c-.1,1.1-.3,2.2-.4,3.3-.1.9,0,1.9.5,2.7.9,1.3,2.8,1.9,4.3,1.5.7-.1,1.4-.5,1.8-1.1.5-.8.2-1.9.9-2.6.3-.4.6-.8.9-1.2q.3-.7.6-1.4c.3-1,.5-2,.7-3c.4-2.3.7-4.6.9-6.8.6-4.7,1.1-9.3,1.2-14q.2-3.5-.1-7Z",
    fill: "#98a89f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790,1413.1q-.2,0-.3-.2c-.3-.4-1.2-.5-1.9-.5q-.5-.1-.9-.1c-.6-.2-1.2-.4-1.8-.5q-.3-.1-.6-.2c-.2-.1-.3-.2-.2-.4c0-.2.2-.3.4-.2q.3,0,.5.1c.6.2,1.2.4,1.8.5.2,0,.5.1.8.1.9.1,2,.1,2.4.9.1.1.1.3-.1.4q-.1.1-.1.1Z",
    fill: "#7d9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.9,1415.1q-.2,0-.3-.1c-.1-.2-.1-.4,0-.5.3-.3.3-1,.3-1.5v-.3c0-.2.1-.3.3-.3s.4.1.4.3v.2c0,.7,0,1.6-.5,2.1q-.1.1-.2.1Z",
    fill: "#7d9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1788.1,1398.7c-.2,0-.3-.1-.3-.2-.1-.2,0-.4.1-.5c1.1-.5,1.5-1.8,1.8-3.2.3-1.5.5-3,.7-4.5q.2-1.4.5-2.8c.2-1.1.5-2.3.8-3.4.3-1.2.6-2.5.8-3.7.4-2.4.4-4.8,0-6.9c0-.2.1-.3.3-.4.2,0,.3.1.4.3.3,2.2.3,4.6,0,7.1-.2,1.3-.5,2.5-.9,3.8-.3,1.1-.6,2.2-.8,3.3q-.2,1.4-.4,2.8c-.2,1.5-.4,3-.7,4.5-.3,1.1-.7,3-2.2,3.7q-.1.1-.1.1Z",
    fill: "#7d9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.5,1402.5c-.6,0-1.7-.5-1.9-.6-.1-.1-.1-.2-.1-.3c0-.2.1-.3.3-.3q0,0,0,0q.2,0,.3.1c.2.1,1.2.5,1.4.4.5-.1.8-1,1-1.8.1-.5.2-.9.4-1.3.1-.1.3-.2.5-.1s.2.3.1.5-.2.6-.4,1.1c-.2.9-.5,2-1.4,2.3q-.1,0-.2,0Z",
    fill: "#7d9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.2,1397.6q-.2,0-.3-.2c-.2-.4-1.4-.8-2.1-1q-.1,0-.3-.1-.3-.1-.7-.2c-.7-.3-1.4-.5-2.1-.7q-.4,0-.9,0c-.4,0-.8,0-1.2-.1-.2,0-.3-.2-.2-.4c0-.2.2-.3.4-.2.3.1.6.1,1,0c.3,0,.6,0,1,.1.8.1,1.5.4,2.3.6q.3.2.6.3.2,0,.3.1c1.1.3,2.2.7,2.5,1.3.1.1,0,.4-.1.4q-.1.1-.2.1Z",
    fill: "#7d9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.6,1399.9c-.2,0-.4-.1-.4-.3v-.6c0-.5,0-1.1,0-1.5q0-.3.1-.6c0-.4.1-.8,0-1s-.1-.4.1-.5c.2,0,.4,0,.5.2.1.3.1.9,0,1.4q0,.3,0,.5c0,.4,0,1,0,1.5v.6c0,.2-.2.3-.3.3Z",
    fill: "#7d9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.6,1399.6c-.1,0-.3-.1-.3-.3q0-.7,0-1.3.1-.8.1-1.6c0-.2.1-.3.3-.3.2-.1.3.1.3.3q.1.8,0,1.6q0,.6,0,1.3c0,.2-.2.3-.4.3Z",
    fill: "#7d9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1776.6,1383.6q0,0,0,0c-.2,0-.4-.1-.4-.3c0-.3-.1-.6-.2-.9q-.1-.4-.2-.8c-.1-.9-.2-1.6-.1-2.3q0-.7,0-1.4c.1-1.6.1-3.3,0-4.9q0-.7,0-1.4c0-2-.1-4.3-1.1-5.8-.6-.8-1.4-1.6-2.1-2.3-.5-.5-1.1-1.1-1.6-1.7-.1-.1-.1-.3,0-.4.2-.2.4-.1.5,0c.5.6,1,1.1,1.6,1.6.7.8,1.5,1.6,2.1,2.4c1.2,1.7,1.2,4.1,1.3,6.2q0,.7,0,1.3c.1,1.7,0,3.4,0,5q0,.7-.1,1.4c0,.7.1,1.3.2,2.2q0,.3.2.7c.1.4.2.7.2,1.1c0,.2-.1.3-.3.3Z",
    fill: "#7d9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.8,1365.6q-.1,0-.2-.1c-1.8-.9-3.8-1.6-5.7-2.3q-.8-.2-1.6-.4c-1.1-.3-2.1-.6-3.1-1.1-.2-.1-.2-.3-.2-.5.1-.1.3-.2.5-.1.9.4,2,.7,3,1q.8.2,1.6.5c2,.6,4,1.4,5.8,2.3.2.1.2.3.2.5q-.1.2-.3.2Z",
    fill: "#7d9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.7,1372.9c-.1,0-.3-.1-.3-.3c0-.9.1-1.8.3-2.7.2-1.1.4-2.2.2-3.3-.4-2.3-.9-3.1-1.1-3.1-.2-.1-.3-.3-.2-.5c0-.1.2-.2.4-.2.2.1,1,.3,1.6,3.7.2,1.2,0,2.4-.2,3.5-.2.9-.3,1.7-.3,2.6c0,.2-.2.3-.3.3q0,0-.1,0Z",
    fill: "#7d9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.8,1377.9q0,0,0,0c-.9-.2-1.8-.6-2.6-.9-.8-.4-1.7-.7-2.6-1-2.1-.5-4.4-.6-6.6-.7-.8,0-1.7,0-2.5-.1-2.5-.1-5.9-.8-7.9-2.1-1.4-1-2.7-2.6-3.3-4.3-.1-.2,0-.4.2-.4.2-.1.4,0,.4.2.6,1.5,1.8,3.1,3,3.9c1.9,1.3,5.2,1.9,7.7,2.1.8,0,1.6,0,2.5.1c2.2.1,4.5.1,6.6.7c1,.2,1.9.6,2.8,1c.8.3,1.6.6,2.4.9.2,0,.3.2.3.4-.1.1-.2.2-.4.2Z",
    fill: "#7d9185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1785.6,1400.9c-.7-.6-1.7-.5-2.6-.5q-1.9,0-3.9,0c-.2,0-.3.1-.3.3q0,2.5-.7,4.9c-.5,1.4-1.3,2.9-1.1,4.4c0,.7.3,1.3.8,1.8.6.5,1.2.8,1.8,1.1c1.3.5,2.8.6,4.1-.1.5-.3,1-.9,1.3-1.5.3-.8.1-1.7.2-2.5q.1-.1,0-.1.1-.9.3-1.8.2-1.7.4-3.5c.2-.8.5-1.9-.3-2.5Z",
    fill: "url(#eRgiJqp653L81-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1787.7,1413.6q-.4-1.5-.8-2.9c-.3-.9-.6-1.8-1-2.7-.6-1.4-1.9-3-3.7-2.8-1.5.2-2.3,1.4-3.4,2.2-.2.1-.6,0-.6-.1.1-.2,0-.4-.2-.4c0-.1-.1-.1-.2-.1-1.5,1.2-2.8,2.5-3.9,4-.6.7-1.2,1.5-1.5,2.3-.4.8-.3,1.7,0,2.5.7,1.7,2.2,3,3.6,4q2.3,1.8,4.9,3.1c.9.4,1.8.8,2.7,1.1s1.9.5,2.8.3c.8-.2,1.6-.8,1.8-1.6.1-.5.1-.9.1-1.3q0-.8,0-1.5c0-2.1-.1-4.1-.6-6.1Z",
    fill: "#f1d6b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.2,1419.2q-.2,0-.3-.2c-.1-.2-.8-.5-3-.6h-.1c-.8,0-1.5.2-2.2.3-.6.2-1.3.3-2,.4-1.5,0-2.2-.9-2.9-1.8q-.2-.2-.4-.4l-.3-.4c-1-1.3-2-2.4-2.7-3.9-.1-.1,0-.3.1-.4.2-.1.4,0,.5.1.7,1.4,1.6,2.5,2.6,3.7l.4.4q.2.3.3.5c.7.9,1.2,1.5,2.4,1.5.6,0,1.2-.2,1.8-.3.8-.2,1.6-.4,2.4-.3h.1c1.5,0,3.1.2,3.6.8.1.2.1.4-.1.5q-.1.1-.2.1Z",
    fill: "#d8b99c"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1736.4,1343.2c1-8.2,2.4-17.1,6.4-24.4c4.3-7.9,13.3-13.6,21.7-13.4c7.3.3,14.4,4.3,19.1,10.4c4.9,6.4,6.1,15.1,7.2,23.4c1.1,8.6.4,16.4,0,24.9c0,1-.1,2-.5,2.8-1.3,2.4-4.3,1.3-6.3,1.3-3,0-6,0-9-.2-7.1-.4-14.2-.6-21.3-.4-5.5.1-17.1,2.1-17.8-6.3-.5-6-.3-12.1.5-18.1Z",
    fill: "#ddcbbc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1743.2,1358.2c.4-2.3,1.3-4.5,2.5-6.2.4-.7.9-1.2,1.1-1.9.4-1.3-.2-2.6.1-3.9.4-1.6,1.3-3.3,1.9-4.9q.2-.4.4-.8.4-1,.8-1.9c1.4-3.2,2.4-5.8,2.3-9.4c0-3-.8-6-1.4-8.9-.4-1.8-1.4-3.9-1-5.7.5-2,3.6-1.3,4.9-1.1c1.5.2,2.5-.6,3.9-.9.8-.1,1.6-.1,2.4-.2.9-.2,1.7-.5,2.6-.7c1.7-.4,3.3.5,5,.5c1.1.1,1.9,0,2.9.5.8.3,1.5.5,2.3.5c2.6.1,6.1-.3,8.1,1.7c1.1,1.2,1.7,2.7,2.3,4.2.8,1.8,1.5,3.6,2.1,5.5q2.2,6.3,3.9,12.7c.9,3.3,2.4,6.6-.2,9.5-1.1,1.4-2.7,2.3-4.1,3.2-.4.3-.8.5-1,.9-.6.7-.5,1.7-.5,2.5c0,2-.2,3.9-.7,5.8-.4,1.7-.5,2.7-2.3,3.2-3.3,1.1-6.6,2.1-10.2,2.3-3.7.1-7.5-.3-11.2.2-2.3.3-4.6.9-6.8,1.5-1.1.2-2.3.6-3.3.6-.9-.1-1.5-.3-2.4.3-.5.4-.9,1-1.5,1.1-.7.2-1.5-.4-1.9-1-.7-1-.9-2.3-1.2-3.5-.3-1.8-.2-3.8.2-5.7Z",
    fill: "#8693a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.1,1315.5c-1.6,0-3.2-.8-4.1-2.1-.1-.2-.1-.4.1-.5.1-.1.4-.1.5.1.8,1.3,2.5,2.1,4.1,1.8.1,0,.3.1.3.3.1.2,0,.3-.2.4q-.4,0-.7,0Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.4,1351.5q-.1,0-.2,0l-2.7-1.3c-.7-.4-1.3-.7-2-1.1-.5-.4-1-.9-1.5-1.3l-2.3-2.1c-1-.9-2-1.9-2.9-3q-.3-.5-.6-1c-.5-.7-.9-1.3-1.5-1.8-.2-.2-.9-.8-.5-1.5c0-.1.3-.2.4-.1.2.1.2.3.1.5c0,0,0,.1.4.6.7.5,1.2,1.3,1.6,2q.3.4.7.9c.8,1,1.8,2,2.8,2.9l2.2,2.1c.5.4,1,.9,1.5,1.3.6.3,1.2.6,1.9.9l2.7,1.4c.2,0,.2.2.2.4q-.1.2-.3.2Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.1,1358.3q0,0-.1,0-3.1-1.3-6-3c-.6-.3-1.1-.6-1.6-1q-.3-.4-.5-.8-.3-.3-.6-.6c-.2-.3-.5-.5-.8-.7q-.4-.2-.7-.5c-.5-.4-.9-.9-1.2-1.3l-3.1-4c-.1-.1-.1-.3.1-.4.1-.1.3-.1.4,0l3.1,3.9c.4.5.7,1,1.1,1.3q.3.2.7.5c.3.2.6.4.9.7q.3.4.6.8.2.3.5.6c.4.4.8.7,1.4,1q2.9,1.6,6,2.9c.1,0,.2.2.1.4c0,.1-.1.2-.3.2Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.2,1353.2q-.2,0-.3-.2c-.2-.3-.4-.7-.7-1q-.1-.2-.3-.4-.7-1-.6-1.9c0-.2.1-.3.3-.3s.3.2.3.4q0,.6.6,1.4.1.2.3.4c.2.4.5.7.7,1.1c0,.2,0,.4-.2.4q-.1.1-.1.1Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.8,1357.6q-.1,0-.1,0c-2.4-.6-4.9-1-7.3-1-.2,0-.4-.1-.4-.3s.2-.3.4-.3q0,0,0,0c2.5,0,5,.3,7.5.9.2.1.3.3.2.4c0,.2-.2.3-.3.3Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.3,1338c-.1-.7-.3-1.5-.4-2.3q0-.5,0-1c-.1-1.3-.1-2.6-.5-3.9c0-.2.1-.4.3-.4.2-.1.3,0,.4.2.4,1.4.4,2.7.5,4.1q0,.4,0,.9c0,.8.2,1.5.4,2.3.2.6.3,1.3.4,2c.4,3.2.3,6.7-.3,11.2v.1c-.1.7-.2,1.5-.2,2.2.1.6.2,1.2.4,1.8.3,1.1.6,2.3.2,3.4-.1.1-.2.2-.3.2q-.1,0-.1,0c-.2-.1-.3-.2-.2-.4.3-1,0-2-.3-3-.1-.6-.3-1.3-.3-1.9-.1-.8,0-1.6.1-2.4v-.1c.6-4.5.7-7.9.3-11.1",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1789.3,1346.6q0,0,0-.1c-.2,0-.3-.2-.3-.4.4-1.3-.1-2.8-1.2-3.5-.9-.6-2-.9-3-.9q0,0,0,0c-1.1,0-2.1.3-2.8,1-.2.1-.4.1-.5,0s-.1-.4,0-.5c.9-.8,2.1-1.2,3.3-1.2s2.3.4,3.4,1.1c1.3.9,1.9,2.6,1.5,4.2-.1.2-.2.3-.4.3Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783.1,1344.6q-.2,0-.3-.1c-.4-.4-.8-1-.9-1.7c0-.1.1-.3.3-.3.1-.1.3,0,.4.2.1.5.3,1,.7,1.3.1.1.1.3,0,.5q-.1.1-.2.1Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784,1344.2q-.2,0-.3-.2c-.3-.4-.6-1-.6-1.6c0-.2.2-.4.4-.4q0,0,0,0c.2,0,.3.2.3.4c0,.4.2.9.4,1.2.2.2.1.4,0,.5q-.1.1-.2.1Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.9,1344.2c-.2,0-.3-.2-.3-.4q-.1-.9.2-1.8c.1-.2.3-.3.4-.3.2.1.3.3.3.5q-.3.8-.2,1.6c0,.2-.2.3-.4.4q0,0,0,0Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.3,1344.1c-.2,0-.4-.1-.4-.3v-1.4c0-.2.2-.3.4-.3s.3.1.3.3v1.4c0,.2-.1.3-.3.3Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.5,1344.3c-.2,0-.3-.2-.3-.4v-.9c0-.2.1-.3.3-.3s.3.1.3.3v.9c0,.2-.1.4-.3.4Z",
    fill: "#6f7889"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1752.5,1322.1c-.4-1.8-1.6-3.9-1.5-5.7.1-.9.4-2.9-1.3-2.5-1.6.4-2.4,1.1-3.4,2.5s-1.5,2.6-1.9,4.2c-.4,1.9-.9,3.5-.3,5.3.6,2,.4,4.4.4,6.4-.1,1.9.7,3.9,1.1,5.8.5,2,1,4.6,2.6,6c.8.7,1.7,1,2.7,1.1c2,.2,4-.6,5.3-2.1.4-.6.8-1.3,1.2-1.9q1.3-2.4,2.6-4.8c1.4-2.5,1.9-3.2-1.1-3.9-1.4-.4-2.5-1.5-3.6-2.5-.8-.8-2-2-2.3-2.7-.5-1.4-.1-3.7-.5-5.2Z",
    transform: "translate(0 0.000001)",
    fill: "#8693a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.9,1336.7q-.1,0-.2,0c-.1-.1-.2-.4,0-.5l.1-.2c.5-.8,1-1.4,1.6-2.1.2-.1.4-.1.5,0s.2.3,0,.5c-.6.6-1.1,1.3-1.6,2l-.1.2q-.1.1-.3.1Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754,1339.5q-.1,0-.1,0c-1.4-.1-2.6-.8-3.6-1.4l-1.6-.8c-.7-.4-1.4-.8-1.6-1.6-.1-.3,0-.4,0-.6q.1,0,.1-.1l.2-1.1q.1-.5.3-1q0-.1.1-.2q0-.1.1-.2c.1-.5.1-.9.1-1.4q0-.2,0-.5q0-1.4.7-2c.2-.1.4-.1.5,0c.1.2.1.4,0,.5q-.5.4-.5,1.5q0,.3,0,.5c0,.5,0,1-.2,1.6q0,.1-.1.3q0,0-.1.1-.1.4-.2.9l-.3,1.1q0,.2-.1.3q0,0,0,0t.1.1c.1.5.7.9,1.2,1.2l1.6.9c1,.5,2.1,1.1,3.3,1.2c1,0,2-.3,2.7-.7q0-.2,0-.3.1-.2.3-.2.6-.2.7-.3c0-.1.1-.3.3-.3.1,0,.3.1.3.3.1.5-.3.7-.8.8q.1.1,0,.2q0,.1-.1.2c-.9.5-2,1-3.3,1Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754,1337.7q0,0,0,0c-.2,0-.4-.2-.4-.4q.1-2,.7-4c0-.2.1-.5,0-.6-.1-.2,0-.4.1-.5.2-.1.4,0,.5.1.2.4.1.9,0,1.2q-.6,1.9-.6,3.8c0,.2-.2.4-.3.4Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.2,1337.3q0,0,0,0c-.2-.1-.4-.2-.3-.4q.2-2.3.8-4.6c0-.2.2-.3.4-.2.2,0,.3.2.2.4q-.5,2.2-.8,4.5c0,.1-.1.3-.3.3Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.1,1336.1c-.1,0-.3-.1-.3-.2-.1-.3,0-.6,0-.8l.8-3.7c.1-.2.3-.3.4-.3.2.1.3.2.3.4l-.8,3.7c-.1.2-.1.3-.1.4.1.2,0,.4-.2.5q0,0-.1,0Z",
    fill: "#6f7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.8,1345.6q-.5,0-1-.1c-.2,0-.3-.2-.2-.4c0-.2.2-.3.4-.3c1.4.3,3-.2,4-1.2c1.6-1.6,1.8-3.9,2-6.3l.4-5c.1-.7.1-1.4-.3-1.8-.2-.1-.2-.3,0-.5.1-.1.3-.1.4,0c.6.6.6,1.5.6,2.3l-.4,5c-.2,2.6-.5,5.1-2.2,6.7-1,1-2.4,1.6-3.7,1.6Z",
    fill: "#6f7889"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1781.9,1299.9c-.1-.1-.1,0,0,0q0,0,0,0t0,0Z",
    fill: "#f6a383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.4,1296.9c-.6-.9-.6-2-.7-3s-.2-2-.6-2.9-.9-1.8-1.7-2.4c-.4-.6-.9-1.2-1.6-1.6-1.1-.7-2.4-.8-3.6-.5-2.5.6-4.8,2.4-6.5,4.3-3.9,4.3-5.2,9.9-6.5,15.4-.2,1.1-.4,2.3-.9,3.3-.4.8-1.1,1.5-1.4,2.4-.8,1.9,1.3,3.5,2.6,4.5.6.4,1.1.6,1.7.8.7.3,1.2.6,2,.8.9.1,1.7.1,2.5.2.8.2,1.8.2,2.4.8.8.6,1,2.1,1.5,3c.9,1.8,2.1-1.5,2.4-2.1.2-.7.4-1.3.8-1.8.2-.3.5-.5.7-.8.7-1.2-.4-2.1-1.1-2.9-.4-.4-.8-1-.8-1.6q.3-1,.6-2q.4-.9.9-1.8c.3-.6.6-1.2,1.3-1.5c1.1-.5,2.4-.4,3.6-.8c1.1-.4,1.8-1.1,1.9-2.3.1-.8,0-1.6,0-2.3q0-.6,0-1.2c0-.3.1-.5.2-.8q.2,0,.4,0c.3-.2.6-.4.7-.8.3-.9-.3-1.7-.8-2.4Z",
    fill: "url(#eRgiJqp653L115-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1780,1294.5q-.1,0-.1,0q0-.1-.1,0q0,0-.1,0q0,.1,0,.1c0,0,0,.1,0,.1q0,0-.1,0q0,.1-.2.2c-.2.2-.4.3-.5.5q-.2.1-.3.4-.1.2,0,.4c0,.4.4.5.7.4q.2-.2.3-.4q0-.2,0-.3t-.1-.2c0,0,.1,0,0-.1q0,0,0-.1-.1-.1-.1-.1c.2-.2.6-.4.6-.7q.1-.2,0-.2Z",
    fill: "#702f28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.7,1292.9c-.4-.1-.8,0-1,.1q-.3.2-.5.4-.1.1-.3.3q0,.1,0,.2-.1,0-.1.1.1,0,.1.1q0,0,0,0c.3,0,.3,0,.5-.1q.1-.1.2-.2t.2-.1q.1-.1.2-.1q0-.1,0-.1t0,0q.1,0,.1,0q.2,0,.3,0q0,0,0,0t0,0q.1,0,.1,0c.2,0,.3.1.4,0c.3-.2,0-.6-.2-.6Z",
    fill: "#702f28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.6,1301.4c-1-.2-3-.8-3.1-.9s-.4.1-.3.2q.1.4.3.8.2.5.5.9c.2.4.5.9,1,1.1.4.3.9.1,1.2-.3.4-.4.5-1,.6-1.5c0-.1-.1-.3-.2-.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.8,1300.2q-.2,0-.3-.1c-.1-.1-.3-.2-.5-.2q-.2-.1-.3-.1c-.2-.1-.3-.3-.2-.5.1-.1.3-.2.4-.2q.2.1.3.1c.2.1.6.2.8.4.1.2.1.4,0,.5q-.1.1-.2.1Z",
    fill: "url(#eRgiJqp653L119-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.7,1298.4q-.1,0-.2-.1c-.4-.5-1-1.2-1.4-1.2-.2,0-.4-.2-.4-.4.1-.1.2-.3.4-.3.8.1,1.7,1.1,1.9,1.5.1.2.1.4-.1.5q-.1,0-.2,0Z",
    transform: "translate(.000001 0)",
    fill: "url(#eRgiJqp653L120-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.2,1315.6q0,0-.1,0c-.1,0-.3-.2-.2-.3q0-.4.1-.7c0-.6.1-1.2.2-1.6.1-.1.3-.3.5-.2.1.1.2.2.2.4-.1.4-.2.9-.3,1.5q0,.3-.1.7c0,.1-.1.2-.3.2Z",
    fill: "url(#eRgiJqp653L121-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2,1317.5c-.2,0-.3-.1-.4-.3-.4-.9-1-1-2.3-1.1q-.2,0-.4,0c-1.1,0-2-.3-3-.6q-.7-.3-1.5-.5c-.2,0-.3-.2-.3-.4.1-.1.2-.3.4-.2q.9.2,1.6.4c1,.3,1.8.6,2.9.7q.2,0,.4,0c1.1,0,2.3.1,2.9,1.5c0,.2,0,.4-.2.4q-.1.1-.1.1Z",
    fill: "url(#eRgiJqp653L122-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772,1317.1q-.2,0-.3-.1c-.1-.2-.1-.4-.2-.5c0-.2.1-.4.3-.4q.3-.1.7-.3c.6-.2,1.2-.5,2-.4.2.1.3.3.3.5-.1.1-.3.2-.5.2-.5-.1-1,.1-1.6.3q-.2.1-.4.2q0,0,0,0c0,.2,0,.4-.2.5q-.1,0-.1,0Z",
    fill: "url(#eRgiJqp653L123-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1759.1,1310.2c2.5,1.7,4.4,4.4,7.1,5.7c1.3.5,2.6.9,3.8,1.4c1.4.7,1.7,2.4,2.2,3.8.2.6.8,1.7.3,2.2-.5-.3-.9-1-1.2-1.5s-.3-1.2-.7-1.7c-.5-.8-1.1-.3-1.6.3-.9.8-2.1,2.7-3.4,2-.6-.3-1.1-.8-1.6-1.3-1.8-1.9-3.9-3.4-5.4-5.5-.7-1-1.4-1.8-1.7-2.9-.3-.9,0-1.1.7-1.7.6-.3.8-.7,1.5-.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.5,1322.5q1-2.3,1.5-4.8c.2-.7.3-1.7.2-2.5c0-.6-.3-1.3-.3-2c.1-.8,1-.9,1.7-.6.7.4,1.2,1.4,1.5,2.1s.5,1.4.6,2.1.3,1.6.2,2.2c-.6-.2-1.2-1.1-1.9-.9-.4.1-1.2.9-1.5,1.3-.8.9-.7,3.1-2,3.6q0-.2,0-.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1782.7,1287.4c-1-.8-2.2-1.4-3.3-1.9q-1.8-.8-3.6-1.5c-2.4-.8-5-1.5-7.5-1.3-1.6.1-3.2.7-4.4,1.7-.5-1.1-1.2-2.2-1.9-3.1-1-1.2-2.2-2.3-3.6-3-1.2-.8-2.9-1.2-4.1-.2-1.3.9-1.6,2.6-1.5,4.1.1,1.4.3,3.1,1.4,4-1.2,1.3-1.5,3.2-.3,4.6.7.7,1.6,1,2.5,1.1c1.1.1,2.2.1,3.2-.1q.1.4.1.7.2.7.3,1.4c.2.8.3,1.7.2,2.5-.3,1.3-1,2.5-2.2,3.2-1,.7-2.2,1.2-3.2,2.1-.9.9-1.3,2.2-.8,3.5.4.9,1.2,1.6,2.2,1.8-.5.8-.4,1.8,0,2.6.4,1.1,1.3,1.9,2.3,2.4c2,1,4.3.9,6.3.3c1.1-.3,2.2-.8,3-1.6.9-.8,1.4-1.7,1.8-2.8q.6-1.3.8-2.8.4-1.4.4-2.8c0-1.1-.2-2.1-1-2.9-.8-.7-1.6-1.4-2.2-2.4q-.2-.5-.3-1q0-.3,0-.5c.1-.5.6-1,1.2-1q.1,0,.2-.1c.7,0,1.4.6,1.9,1.1.5.6.9,1.3,1.9,1.7.1.1.2.1.3.1c1.1.3,2.2-.6,2.5-.9.7-.9,1.2-1.9,1.7-2.8q.3-.6.6-1.2.2-.3.4-.6c.2-.3.5-.6.8-.6s.5.2.8.3c.4.4.7.6,1.2.8q.7.1,1.4,0c.9-.2,1.7-.9,1.9-1.8.2-1.2-.5-2.3-1.4-3.1Z",
    fill: "#702f28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.8,1290.1c-.1,0-.3-.1-.3-.2-.4-1.3,1.3-4.4,2.6-4.8.2-.1.4,0,.4.2.1.2,0,.4-.2.4-.8.3-2.2,2.7-2.2,3.7q0,.1,0,.1c.1.1.1.2.1.3q-.1.2-.3.3-.1,0-.1,0Z",
    fill: "#541919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.4,1310.6q0,0-.1-.1c-.1,0-.3-.1-.3-.3s.2-.3.3-.3q.1,0,.1,0c1.5,0,2.5-1.2,3-2.2c1.3-2.5,1.3-6.2.1-7.8-.1-.2,0-.4.1-.5.2-.1.4-.1.5.1c1.3,1.8,1.3,5.8-.1,8.5-.9,1.6-2.1,2.6-3.6,2.6Z",
    fill: "#541919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.6,1310q-.1,0-.1,0c-.2-.1-.3-.2-.3-.4q.4-2,1.8-2.7.6-.2,1.2-.4c.5-.1.9-.3,1.3-.5c1.3-.7,2.4-2.4,1.9-3.9-.1-.2,0-.4.2-.5.2,0,.4.1.4.3.7,1.9-.6,3.9-2.2,4.7-.4.2-.9.4-1.4.5q-.6.2-1.1.5c-.7.3-1.2,1-1.4,2.1c0,.2-.2.3-.3.3Z",
    fill: "#541919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.5,1295.5c-.2,0-.3-.1-.3-.2-.1-.2,0-.4.2-.4c1.6-.4,3-2.1,3.3-3.9c0-.1.2-.3.4-.2.2,0,.3.2.3.3-.3,2.1-2,4-3.8,4.4q-.1,0-.1,0Z",
    fill: "#541919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.6,1294.7q-.2,0-.3-.1c-.1-.1-.1-.4,0-.5.4-.3.8-.5,1.2-.7.7-.4,1.5-.8,1.6-1.5.1-.2.2-.3.4-.3s.3.2.3.4c-.2,1-1.1,1.5-2,2-.4.2-.8.4-1,.6q-.1.1-.2.1Z",
    fill: "#541919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.9,1285.7c-.1,0-.3-.1-.3-.3-.2-.9-1.2-2.1-1.9-2.8-1.5-1.4-2.8-2.5-4.1-1.3-.1.1-.3.1-.4,0-.2-.1-.2-.3,0-.5c1.8-1.8,3.7.1,4.9,1.3.4.4,1.8,1.8,2.2,3.1c0,.2-.1.4-.3.5q0,0-.1,0Z",
    fill: "#541919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.7,1286q-.2,0-.3-.2c-.6-1.1-1.5-1.7-2.5-2.3q-.2-.2-.5-.4c-.1-.1-.2-.3-.1-.5.1-.1.4-.1.5,0q.3.1.5.3c1.1.7,2,1.4,2.7,2.6.1.1,0,.3-.1.4q-.1.1-.2.1Z",
    fill: "#541919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.8,1290.5q0,0,0,0c-.8-.1-1.5-.4-2.1-.8-.2-.1-.2-.3-.1-.5.1-.1.3-.2.5-.1.5.4,1.1.6,1.8.7.2,0,.3.2.3.4-.1.1-.2.3-.4.3Z",
    fill: "#541919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.1,1301.9q-.1,0-.2-.1c-.2-.1-.2-.3,0-.4q.2-.3.5-.5c.9-.8,1.7-1.6,2.1-2.7.4-1,.2-2.1,0-3.1v-.1c-.3-1.3-.6-2.7-.2-4.1.1-.2.2-.3.4-.2.2,0,.3.2.3.4-.4,1.2-.1,2.6.1,3.8l.1.1c.2,1.1.4,2.2,0,3.4-.5,1.3-1.4,2.2-2.4,3q-.2.2-.5.5-.1,0-.2,0Z",
    fill: "#541919"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1751.5,1314.7c-.6-.9-1.4-2.1-1.4-2c.2-.4.7-.9.1-1.3-.3-.2-.8-.1-1.2,0c.3-.4,1-.9.5-1.4-.2-.4-.6-.5-1-.5-.2-.1-.3-.2-.4-.3.4-.6-.1-1.4-.7-1.6-.7-.2-1.4,0-2.1.3q-1,.3-2.1.7-.1-1.3.2-2.5c.1-.6.2-1.2.2-1.8c0-.5-.3-1.4-.8-1.5-.5,1.2-1.2,2.6-1.3,4-.2,1.5-.1,3,0,4.5c0,.8.1,1.7.7,2.3.1.1.3.2.4.3c0,.2,0,.3,0,.5.2.4.7.5,1.2.5-.1.8.8,1.4,1.5,1-.2.1,1.8,1.3,2,1.5c1.7,1.4,2.1,3.5,2.1,5.6.1,2.2,0,4.4-.3,6.5c0,.2,0,.4.1.6q.1.1.3.2c1.9.9,5.6,2.2,7.3.2.8-1-.1-3.1-.5-4.1-1.2-3.6-2.3-7.4-4.1-10.7-.1-.2-.3-.5-.7-1Z",
    fill: "url(#eRgiJqp653L139-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.5,1315.1q-.1,0-.2,0c-.2-.1-.2-.3-.1-.4q.1-.3.1-.6c.1-.3.1-.6.3-.9.2-.4.6-.6.9-.7s.5-.2.6-.4c.1-.1.3-.2.4-.1.2.1.3.3.2.4-.2.4-.6.6-.9.7s-.5.3-.6.5q-.2.2-.2.6c-.1.2-.1.5-.2.8q-.1.1-.3.1Z",
    fill: "url(#eRgiJqp653L140-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747,1313.5q-.1,0-.1,0c-.2-.1-.3-.3-.3-.5.4-1,1.4-1.8,2.5-1.9.2,0,.4.1.4.3s-.1.3-.3.3c-.9.1-1.7.7-1.9,1.5-.1.2-.2.3-.3.3Z",
    fill: "url(#eRgiJqp653L141-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.7,1311.9q-.1,0-.1-.1c-.2,0-.3-.2-.2-.4q.3-.7.7-1.3c.1-.2.2-.4.4-.5q.3-.2.6-.3q1-.2,2.1-.4c.1,0,.3.1.3.3.1.2,0,.3-.2.4q-1,.1-2,.4-.2,0-.4.1-.1.1-.3.3-.3.6-.6,1.2c0,.2-.2.3-.3.3Z",
    fill: "url(#eRgiJqp653L142-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.7,1311.3q-.1,0-.1,0c-.2,0-.3-.2-.3-.3.1-.9.2-1.9.7-2.7.1-.2.3-.3.4-.2.2.1.3.3.2.5-.4.7-.5,1.6-.6,2.4c0,.2-.2.3-.3.3Z",
    fill: "url(#eRgiJqp653L143-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.6,1314.1c-.1,0-.3-.1-.3-.3q-.1-.3.1-.6c.1-.2.3-.2.4-.2.2.1.3.3.2.5q-.1.1,0,.3c0,.1-.1.3-.3.3q-.1,0-.1,0Z",
    fill: "url(#eRgiJqp653L144-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.8,1315.2q-.1,0-.1,0c-.2,0-.3-.2-.3-.4q0-.3.2-.6c.1-.2.3-.2.5-.1.1.1.2.3.1.4q-.1.2-.1.4c0,.2-.2.3-.3.3Z",
    transform: "translate(0 0.000001)",
    fill: "url(#eRgiJqp653L145-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.2,1316.4q0,0-.1-.1c-.2,0-.2-.2-.2-.4l.2-.5c.1-.2.3-.2.5-.2.1.1.2.3.1.5l-.1.4c-.1.2-.2.3-.4.3Z",
    fill: "url(#eRgiJqp653L146-fill)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1858.6,1368.1c.1-2,.8-9.8-3.3-9.3-.2,0-.4.1-.4.4-.1,1.2-.1,2.5,0,3.8q0,.1,0,.1c-.2,10-.1,20-.1,29.9q0,8.5,0,16.9c0,4.7-1.2,22.8.8,26.4.1.2.4.2.6.1c1.3-.6,1.6-23.6,1.9-27.5.5-8,.5-16,.4-24-.1-4-.3-7.9-.2-11.8.1-1.7.2-3.3.3-5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1751.9,1449.2c-1.2-1.4-3.3-2.9-4.1-4.5-.9-1.7-1.3-3.6-1.7-5.5-.3-1.3-.4-2.8-1-4-.3-.7-1-1.1-1.7-1.3-1.7-.6-3.6-.8-5.4-.9-1.6-.1-4.4.1-3.5,2.5.2.6.6,1.2.9,1.8.4.9.6,1.8.8,2.6.6,2.1.9,4.2,1.4,6.3q.1.8.3,1.7c.1.7.2,1.5.5,2.1.9,1.6,3.4,1.9,5,2.2c2.8.5,5.8.6,8.7.6.2,0,.4-.2.4-.4-.1-1.2.2-2.3-.6-3.2Z",
    fill: "url(#eRgiJqp653L151-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.6,1456.7c-1.4-1.1-3-1.9-4.5-2.9-1.2-.9-2.4-1.8-3.7-2.6-1.3-.9-2.8-1.6-4.2-2.4-1.1-.7-2.1-1.6-3.4-.9-1.3.8-1.7,3-3.4,2.9-1.1,0-1.5-.9-2.2-1.6-.5-.3-.9-.5-1.4-.6-1.5-.4-3.1-1.6-4.7-1.6-.1,0-.3.2-.4.3-.2.9-.3,1.8-.2,2.6-.2.6-.2,1.2-.2,1.8-.1,1.5.2,2.9.6,4.4.3,1,.7,2.2,1.6,2.9.9.8,2.2.9,3.4,1.1c3.6.5,7.2.5,10.9.8q5,.3,10,.3c1.2,0,4,.8,4.3-1.1.2-1.4-1.6-2.7-2.5-3.4Z",
    fill: "#f9f5f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.3,1458.9q-.2,0-.3-.2-.1,0-.2,0-.2.1-.4.1-.3-.1-.5-.1-.3-.1-.5-.1c-.3,0-.5-.1-.8-.2q-.2-.1-.5-.2-.6-.1-1.2-.1c-1.2.1-2.5.1-3.7.2-1.3.1-2.7.1-4.1.2q-.7-.1-1.4-.1-.4-.1-.7-.1t-.5,0c-.4,0-.9,0-1.3-.2-.6-.1-1.1-.3-1.5-.4-.7-.3-1.4-.4-2.1-.4q-.6-.1-1.2-.2c-.7-.1-1.4-.1-2.2-.2q-.3,0-.6-.1-.5,0-.9,0c-.2,0-.3-.2-.3-.4s.2-.3.3-.3q0,0,0,0q.5,0,.9.1.4,0,.7,0q1.1.1,2.2.3.6,0,1.2.1c.7.1,1.5.2,2.2.4q.7.3,1.4.5c.4.1.8.1,1.2.1q.3,0,.5,0q.4.1.7.1c.5,0,1,.1,1.4.1c1.4,0,2.7-.1,4.1-.2c1.2,0,2.4-.1,3.7-.1.4,0,.9,0,1.3.1q.4.1.7.2t.6.1q.2.1.5.1.2.1.5.1.1,0,.2,0c.2,0,.5-.1.7,0q.2.1.2.3v.1c.1.2-.1.4-.2.4q-.1,0-.1,0Z",
    fill: "#ebe0d7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1749.9,1396c-1.2-1.6-2.1-3.3-3.2-4.9s-2.4-3-3.5-4.6c-.1-.1-.2-.2-.4-.2-1.6.5-3.4.6-5,1.2q-.3.1-.6.2c-1.1.1-2.2-.1-3.3.1-2.6.5-.4,3.1.4,4.3.6,1,1,2.4,1.9,3.1s2.1.3,3.1,0c1.8-.4,3.9-.3,5.7.1c1.5.3,3,1.2,4.5,1.3.3,0,.5-.4.4-.6Z",
    fill: "url(#eRgiJqp653L156-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.6,1402.4c-1.1-4.3-3.3-8.6-5.7-12.3-.6-1-1.2-2-1.9-2.8-.6-.8-1.3-1.4-1.9-2.1-.5-.5-.9-1.1-1.6-1.2-.8-.2-1.7.2-2.5.3-.9.2-1.9.4-2.8.7-.6.1-1.4.3-1.9.7-.8.7-.2,1.3.5,1.8q.1,0,.1,0c.8.8,1.6,1.4,2.3,2.2c1.5,1.8,2.8,3.6,3.9,5.6q0,0,0,.1c0,.4-.5.6-.5,1s.3.8.6,1.1q.6.7,1.2,1.5c.1.2,1.3,1.4,1.3,1.3q0,0,0,0q0,.1.1.1q0,.1,0,.1.4.6.8,1.1c1.2,1.5,2.6,2.9,4.2,3.8c1,.6,3,1.5,3.9.3.7-.9.2-2.3-.1-3.3Z",
    fill: "#ddcbbc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1757.1,1404.3c-.1,0-.3-.1-.3-.2-.1-.5-.3-.9-.4-1.3q-.1-.2-.2-.3-.1-.5-.3-.9-.3-.7-.6-1.4c-.5-1.2-1.1-2.5-1.7-3.6q-.6-1.2-1.1-2.4c-.3-.6-.7-1.2-1.1-1.8q-.4-.5-.7-.9c-.4-.8-.9-1.4-1.6-2.2-.6-.7-1.2-1.4-2-2q-.2-.3-.4-.5-.2-.3-.4-.5c-.1-.1-.2-.3-.1-.5.1-.1.4-.1.5,0c.2.1.4.4.5.6q.2.2.4.4c.7.6,1.4,1.4,2,2.1.7.8,1.2,1.4,1.7,2.2q.3.5.6.9c.4.6.9,1.2,1.2,1.9q.5,1.2,1.1,2.4c.6,1.2,1.2,2.4,1.8,3.6q.3.8.5,1.5.2.4.4.8l.1.3c.2.5.4.9.5,1.4c0,.2-.1.4-.3.4q0,0-.1,0Z",
    fill: "#c9b5a7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1746.5,1437c-1.4-6.9-2.6-13.7-3.8-20.6-1.1-6.2-2.6-12.2-5.6-17.7.7-.2,1.5-.5,2.2-.9.1-.1.2-.4.2-.6-.6-1.7-1.4-3.3-2-4.9-.5-1.2-.7-2.4-1.2-3.6-.9-2.5-2.7-2.5-5-2.1-1.4.3-2.7.6-4.1.6-.5-2.6-2.9-4.6-5-5.9-2.7-1.8-5.9-2.5-9-3.1-3.3-.8-6.6-2-9.9-2.7q-1.6-.3-3.1-.6c-.6-.6-1.3-.8-2.1-1.1-1-.3-1.9-.8-2.9-1-2-.4-4.2.5-6.1.9-5,1.3-10,2.5-15.2,3.2-3.3.5-6.7.4-10,1-2.3.4-5,.9-6.8,2.6-1.7,1.5-1.6,3.6-.5,5.3c1.2,3.3,2.1,7,4.6,9.5c3,3,7.3,3.4,11.3,3.9c4.8.5,9.8,1.5,14.3,3.2c4.9,1.7,9.4,4.1,14.6,4.7c2.7.4,5.4.4,8.1,0c1.9-.3,3.9-.5,5.8-.9c1.4,2.8,2.3,6,3.8,8.7.9,1.8,1.9,3.6,3.1,5.2c1.1,1.5,2.4,2.9,3.2,4.6s1.2,3.5,2,5.2c.6,1.6,1.6,3,2.8,4.2c1.3,1.3,2.5,2.5,3.7,3.9.7.9,1.5,1.1,2.6,1.1c3.2-.1,7,.1,9.7-1.6.2-.1.3-.3.3-.5Z",
    fill: "#894a3f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1715.9,1406.3q-.1,0-.2,0c-.2,0-.3-.2-.3-.4.1-.2.3-.3.4-.2q.1,0,.1,0q.1-.1.2-.2c.3-.1.7-.1,1-.2h.1c1.1-.1,2-.2,2.8-.4c1.2-.3,2.4-.8,3.5-1.2.8-.3,1.5-.6,2.3-.8.5-.2.9-.4,1.3-.6.6-.3,1.1-.6,1.7-.7.4-.2.8-.3,1.1-.5q.5-.3,1-.4.6-.2,1.1-.5.4-.3.9-.5.2-.1.5-.2c.5-.2,1.1-.5,1.8-.5q0,0,0,0c.2,0,.3.2.3.3c0,.2-.1.4-.3.4-.6,0-1,.2-1.6.4q-.2.2-.5.3-.4.1-.8.4c-.3.2-.7.4-1.1.5q-.5.2-1,.4c-.4.2-.8.4-1.2.5-.6.1-1,.4-1.6.7-.4.2-.9.4-1.4.6-.8.2-1.5.5-2.2.8-1.2.5-2.4,1-3.6,1.2-.9.2-1.8.4-2.9.5h-.1c-.3,0-.6.1-.9.1q0,.1,0,.1c-.1,0-.2.1-.4.1Z",
    fill: "#7f3d36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.6,1408h.2l-.2-.1q0,0,0,.1Z",
    fill: "#7f3d36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.1,1406.2q-.3,0-.6,0-.2-.1-.4-.1-.2-.1-.3-.1c-.1,0-.3-.1-.3-.3-.1-.2.1-.3.2-.4.3,0,.5.1.7.1q.1.1.2.1c.4.1.9,0,1.3,0c1.1-.1,2.4-.7,3.1-1.5.5-.6,1.1-1.1,1.7-1.6.5-.3.9-.7,1.3-1.1q.8-.8,1.7-1.5.4-.4.9-.6.3-.2.6-.5c.6-.4,1.1-.7,1.8-.9q.4-.2.8-.4c.4-.2.9-.4,1.4-.5l1-.3c1.3-.5,2.7-.9,4-1.4c1-.4,2-.8,3-1.3q.8-.4,1.6-.7c.7-.3,1.4-.7,2.1-1.1q.6-.3,1.3-.7c.2-.1.4,0,.5.2.1.1,0,.3-.2.4q-.6.3-1.3.7c-.7.4-1.4.8-2.1,1.1q-.8.4-1.6.7c-1,.5-2,1-3.1,1.3-1.3.5-2.7,1-4,1.4l-1,.3c-.5.1-.9.3-1.3.5q-.5.2-.9.4c-.6.2-1.1.5-1.6.9q-.3.2-.6.4-.5.3-.9.6-.8.7-1.6,1.5-.7.6-1.4,1.2c-.5.4-1.1.9-1.6,1.4-.8,1-2.2,1.6-3.5,1.8q-.5,0-.9,0Z",
    fill: "#7f3d36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.9,1396.5c-.8,0-1.4-.8-1.8-1.3l-.1-.1c-.6-.7-1-1.4-1.3-2q-.2-.3-.3-.6c-.5-.8-1-1.7-1-2.6c0-.2.2-.4.3-.4.2,0,.4.2.4.4c0,.7.4,1.6.9,2.3q.1.3.3.5c.3.7.7,1.3,1.2,1.9l.1.2c.3.4.8,1.1,1.3,1.1q0,0,0,0c.2,0,.3.1.3.3s-.1.3-.3.3q0,0,0,0Z",
    fill: "#7f3d36"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1638.6,1383.2c.1-2.2.8-10.6-3.2-10.1-.3,0-.5.2-.5.5-.1,1.3,0,2.7,0,4q0,.1.1.2c-.3,10.7-.2,21.4-.2,32.1q0,9,0,18.1c0,5.1-1.2,24.5.8,28.3.1.2.4.3.6.2c1.3-.7,1.7-25.4,1.9-29.6.6-8.6.5-17.2.4-25.8-.1-4.2-.2-8.4-.1-12.6c0-1.8.2-3.6.2-5.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.8,1400.7c.1-2.1.8-9.9-3.2-9.5-.3.1-.5.2-.5.5c0,1.2,0,2.5,0,3.8q0,.1.1.1c-.3,10.1-.2,20.2-.2,30.3q0,8.5,0,17.1c0,4.8-1.2,23,.8,26.7.1.2.4.2.6.1c1.3-.6,1.7-23.9,1.9-27.9.6-8.1.5-16.2.4-24.3-.1-3.9-.2-7.9-.1-11.9c0-1.6.2-3.3.2-5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1860.2,1360.7c-.3-.4-.7-1-1.2-1.1-5.4-2.5-11.4-3.3-17.2-4.7-9.9-1.9-19.7-4.8-29.9-4.9-6.3,0-12.7,1.4-19,2-3.2.5-6.5.5-9.7.8-3.2.5-6.4,1.4-9.7,1.7-13.4,2-26.5,6.7-40.1,6.3-30.5,4.5-61,9.2-91.7,11.4-2.2.3-8,.9-7.7,2.4-.1.9-.2,1.8-.1,2.7c3.5,3.4,9,4.6,13.3,7.1c10.7,6.2,22.6,10,34.5,13.4c2.1.5,4,.1,6-.3c10.5-2.5,21.1-4,31.6-6.2c15.3-3.3,29.1-4.8,44.1-7c11.4-2.3,22.9-3.9,34.2-6.4c7.4-1.4,14.7-4.3,22.2-4.6c12.3-.6,24.3-4.7,36.5-6.5c1.4-.2,3.3-.6,3.7-2.2.2-1.3,1-2.7.2-3.9Z",
    transform: "translate(-2 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.1,1394.6c-.6,0-1.1-.2-1.6-.4q-.1-.1-.3-.1c-.4-.2-.8-.3-1.3-.6q-.4-.2-.9-.3-.3-.1-.6-.2-.7-.3-1.3-.5-.5-.1-.9-.3-.8-.3-1.6-.6-.5-.2-.9-.4l-.9-.3c-1.5-.7-3.1-1.3-4.7-1.8q-.5-.2-1-.5-.5-.2-.9-.4-.4-.1-.8-.2-.3-.1-.6-.2c-.8-.2-1.5-.5-2.2-.9q-.3-.1-.7-.2-1.3-.6-2.6-1c-1.2-.5-2.4-1-3.6-1.5-2.3-1-4.5-1.9-6.6-2.8q-.6-.2-1.1-.5-.7-.3-1.5-.6-.5-.2-1-.3-.5-.2-1.1-.4c-1.1-.4-2-1-2.9-1.7-.6-.3-1.1-.7-1.7-1-.5-.3-1-.4-1.5-.6-.6-.3-1.3-.5-1.9-.9-.2-.1-.2-.3-.1-.5.1-.1.3-.2.5-.1.5.4,1.1.6,1.8.9.5.1,1,.3,1.5.6q.9.5,1.7,1.1c.9.6,1.8,1.2,2.8,1.6q.6.2,1.1.4.6.1,1.1.3.7.3,1.5.6.5.3,1,.5c2.2.8,4.4,1.8,6.7,2.8c1.2.5,2.4,1,3.5,1.4q1.4.5,2.7,1.1.3.1.6.2c.8.3,1.4.6,2.2.9q.3,0,.6.1.4.1.8.3.5.2,1,.4.5.3.9.4c1.6.6,3.2,1.2,4.8,1.8l.8.4q.5.2,1,.4c.5.2,1,.4,1.5.6q.4.1.9.3.7.2,1.4.4.2.2.5.2c.4.1.7.3,1,.4.4.3.9.4,1.3.6q.1,0,.2.1c.5.1.9.3,1.4.3.7,0,1.5-.2,2.3-.4q.2,0,.5-.1c1-.2,2.1-.6,3.1-1c1.4-.4,2.9-1,4.5-1.2.8,0,1.5-.2,2.2-.4q.7-.2,1.5-.4.9-.2,1.8-.4q1.3-.2,2.6-.5c2.2-.5,4.5-.9,6.7-1.3q1.7-.3,3.4-.6.3-.1.6-.1c1.1-.3,2.3-.5,3.5-.4q.2.1.4.1.3.1.7.1c.3,0,.6-.1,1-.2q.4-.1.8-.2t.8-.1q.7-.1,1.4-.2c.7-.2,1.5-.4,2.2-.6c1.2-.4,2.6-.8,4-.8c2,0,4-.4,6-.8c2.2-.4,4.3-.6,6.4-.8l.8-.1c1.4-.1,2.7-.4,4.1-.6q1-.2,2.1-.3q1-.2,1.9-.2.9-.1,1.7-.2c.9-.1,1.8-.4,2.7-.6q.7-.2,1.4-.4c1-.3,2-.6,3-.9l.8-.2c.8-.3,1.7-.4,2.6-.5q.5-.1,1-.2q1.1-.1,2.1-.4c1.4-.3,2.9-.6,4.3-.6.4,0,.7,0,1-.1q.4-.1.7-.1c.9-.1,1.9-.4,2.8-.7c1.2-.5,2.6-.8,4.2-1.1q.8-.1,1.6-.2l.6-.2q.5,0,.9,0c.4-.1.8-.1,1.1-.2q.7-.1,1.3-.3.9-.2,1.7-.4t1.6-.4q.7-.3,1.5-.5c1-.2,2.1-.3,3.2-.5.8-.1,1.6-.2,2.4-.3c1-.2,1.9-.3,2.9-.4s2.1-.2,3.1-.4q1.4-.3,2.7-.6c1.5-.3,3-.6,4.4-.9q.7-.2,1.5-.4c1.3-.3,2.7-.7,4-.8c1.4,0,2.7-.4,4.1-.7q.8-.2,1.5-.4t1.4-.3c1-.2,2-.3,2.9-.7c1.2-.5,2.6-.8,4-1.1q.6-.1,1.2-.2.7-.1,1.4-.2.6,0,1.2-.2.5-.1,1-.1.7-.2,1.4-.3.7-.2,1.4-.3.4,0,.8-.1.6-.1,1.2-.3c.6-.2,1.1-.3,1.7-.4q.3,0,.6,0c.8-.1,1.6-.2,2.2-.4c1-.4,1.9-.5,2.8-.7l.4-.1c.4,0,.9-.2,1.3-.3q.3-.1.6-.2.4-.1.9-.1.3,0,.6-.1.2,0,.3-.1c.4-.1.8-.2,1.3-.2.3,0,.5,0,.8-.1q.2,0,.6-.1c.3,0,.6,0,.9,0q.2,0,.4,0c.3,0,.5-.1.7-.1q.1-.1.3-.1c.4-.2.8-.2,1.2-.2.7-.1,1.3-.2,1.8-.7.2-.1.4-.1.5,0s.1.3,0,.5c-.6.6-1.5.7-2.3.8q-.5.1-1,.2-.1.1-.3.1c-.2.1-.4.2-.9.2q-.2,0-.4,0c-.3-.1-.6-.1-.9,0q-.2,0-.4.1c-.3,0-.6.1-1,.1s-.7.1-1.1.2q-.2,0-.3.1-.4,0-.8.1-.4,0-.7.1t-.7.2q-.6.2-1.2.3l-.5.1c-.9.1-1.8.3-2.6.6-.7.3-1.6.3-2.4.4q-.3.1-.6.1c-.5.1-1.1.2-1.6.3q-.6.2-1.3.4-.4,0-.9.1c-.4,0-.8.1-1.2.2q-.8.2-1.5.3-.5.1-1,.2-.6.1-1.3.2-.6,0-1.3.2-.6.1-1.2.2c-1.3.3-2.7.6-3.9,1-1,.4-2,.6-3,.8q-.6.1-1.3.2-.8.2-1.5.4c-1.4.4-2.8.8-4.3.8-1.2.1-2.5.4-3.8.8q-.8.2-1.5.4c-1.5.3-3,.6-4.4.9q-1.4.2-2.7.5c-1.1.2-2.2.4-3.2.5s-1.9.2-2.9.3c-.8.2-1.6.3-2.4.4-1.1.1-2.1.2-3.1.5q-.8.2-1.5.4-.8.2-1.6.4-.9.3-1.7.5-.7.1-1.3.3c-.4.1-.8.1-1.2.1q-.5,0-.9.1l-.6.1q-.8.1-1.6.3c-1.5.3-2.9.5-4.1,1-.9.4-1.9.6-2.9.7q-.3.1-.6.1c-.4.1-.7.2-1.2.2-1.4,0-2.8.3-4.2.6q-1,.2-2.1.4-.5.1-1,.2c-.8.1-1.7.2-2.5.5l-.8.2c-1,.3-2,.6-3.1.9q-.6.1-1.3.3c-.9.3-1.9.6-2.8.7q-.9.1-1.7.2c-.7,0-1.3,0-1.9.1q-1.1.2-2.1.4c-1.4.2-2.7.4-4.1.6h-.8c-2.1.2-4.2.5-6.3.9s-4.1.7-6.2.8c-1.3,0-2.5.3-3.8.7-.8.3-1.5.5-2.3.6q-.7.2-1.5.3-.3,0-.7.1-.4,0-.8.1c-.3.1-.7.2-1.1.3-.3,0-.6-.1-.9-.1q-.1-.1-.3-.1c-1-.1-2.2.1-3.2.3q-.4.1-.7.1-1.7.4-3.3.7c-2.3.4-4.5.8-6.8,1.3q-1.3.3-2.5.5-1,.2-1.9.4-.7.1-1.4.3c-.7.2-1.5.4-2.3.5-1.5.2-3,.7-4.4,1.2-1,.3-2.1.7-3.2.9q-.2.1-.5.2c-.8.2-1.6.4-2.4.4Z",
    fill: "#ddcbbc"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1793.2,1353.2c.1-1.1-.1-1.9-1.4-2.7-.7-.4-1.6-.8-2-1.5-.6-1.1,0-3.5-1.3-4-.8-.2-1.7-.3-2.5-.1-1,.3-2.1.9-2.4,1.9-.3.7-.1,1.2,0,1.9.1.8-.5,1.5-.9,2.2-.2.6-.1.9-.2,1.5-.2,1.2-.6,2.7-1.6,3.6-.1.1-.3.2-.4.5-.3,1,2.1.5,2.5.3.5-.4.9-1,1.3-1.5.6-.7,1.6-1.3,2.4-.5c1.3,1.3,2.5,3,3.5,4.6.7,1,1.7,1.9,2,.2.3-1.6.1-3.1.6-4.8.2-.6.3-1.1.4-1.6Z",
    fill: "url(#eRgiJqp653L173-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.2,1357.3q-.2,0-.3-.2-1-1.7-2-3.4c-.1-.1-.1-.3.1-.4.1-.1.3-.1.4.1q1.1,1.6,2.1,3.4c.1.1,0,.3-.2.4q0,.1-.1.1Z",
    fill: "url(#eRgiJqp653L174-fill)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1663.8,1298.6q-.1,0-.1,0t0-.1q-.2-.2-.4-.3-.2-.2-.4-.4-.1-.2-.3-.3-.2-.2-.4-.3-.5-.3-.9-.5-.5-.2-1-.2c-.8-.1-1.4.3-1.8.8-.3.5-.5,1.2-.5,1.9c0,1.2.8,2.6,1.9,3.5c1.2.8,2.6,1.2,3.8.4q.3-.1.5-.3t.3-.5q.1-.4.2-.9q0-.4-.1-.9t-.3-1-.5-.9Z",
    fill: "url(#eRgiJqp653L176-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.1,1297.3q-.1.3-.1.7q0,.3,0,.7.1,1.1.3,2.1t.4,1.9c.3,1,.3,1.8.1,2.6-.2.9-.5,1.7-.9,2.5q-.4,1-.9,1.9t-1,1.8q-.3.5-.6.9t-.7.9q-.2.3-.5.6-.2.3-.5.6-.2.1-.3.1-.1.1-.3.2q0,0,0,0t0,0q-.2.1-.3.1-.2.1-.3.1t-.1,0t0,0l-.1.1h-.1q-.3,0-.6.1-.2,0-.5,0c-.2,0-.5.1-.7.1s-.4,0-.4,0v.1.1q0,.1,0,.2q0,0,0,.1q0,.3,0,.6q0,.4,0,.7.1.4.1.7.1.4.2.8q0,.2,0,.3.1.2.1.3.1.6.3,1.2.1.6.3,1.1c.2.4.4.7.6,1.1.1.3.1.6-.2.9-.7.7-1.6,1.2-2.5,1.5-.9.4-1.9.6-2.8.8q-1.6.4-3.1.4-1.6,0-3.2-.4c-.9-.3-2-.7-2.9-1.3-1-.6-1.8-1.4-2.4-2.2q0-.1,0-.1t0,0c-.2-.4-.3-.4-.4-.5c0,0,.1-.1.2-.4q0,0,.1,0q0-.1.1-.2.2-.2.6-.9t.9-1.7q0-.1.1-.2q0-.1.1-.3c.4-1.1.7-2.2.9-3.3.2-1,.3-2,.3-3q0,0,0-.1q0,0,0,0q0-.6,0-1.1t0-1q-.1-1.1-.1-2.2-.1-1.1-.2-2.1q0-.3-.1-.6q0-.3-.1-.6q0-.8-.1-1.7-.1-.8-.2-1.6-.1-.2-.1-.4t0-.3q-.2-1.2-.4-2.5-.1-1.2-.4-2.4-.2-1.1-.4-2.3-.3-1.2-.4-2.4v-.1-.2c0-.4,0-.7.1-1c.2-.3.4-.6.7-.9q.1-.2.2-.3t.2-.2q.3-.3.6-.6.3-.2.7-.4.2-.2.5-.3.2-.1.5-.2.1-.1.2-.1.1-.1.3-.1.1,0,.2-.1.1,0,.2,0q.1-.1.3-.1.1-.1.3-.1q1.3-.3,2.5-.5q1.2-.3,2.5-.4q1.7,0,3.3-.1q1.7,0,3.4,0q.3,0,.6,0t.7,0q.1-.1.2-.1.2,0,.3,0t.2,0t.2.1q.1,0,.2,0q0,0,.1,0q.2,0,.4,0q.1.1.3.1.4.1.7.3.4.2.6.5.1.1.2.2.1.2.2.3c.6.9,1,1.8,1.4,2.8.3.9.6,1.9.7,2.8q.1.6.1,1.2t-.1,1.2q-.1.8-.3,1.6-.1.8-.2,1.6Z",
    fill: "url(#eRgiJqp653L177-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1683.5,1286.1c-.1.2-.4.3-.6.4-.2.2-.4.3-.5.3q-.6.4-1.2.6-.6.3-1.2.5-1.2.4-2.4.6-1.1.3-2.3.5-1.2.1-2.3.2-1.2,0-2.3.1c-.3,0-.7,0-1.1,0-.3,0-.7.1-.9.2-.4.2-.6.5-.8.8-.1.4-.2.8-.3,1.1-.3.8-.4,1.6-.5,2.4c0,.9,0,1.7,0,2.5q0,1.4,0,2.8.1,1.4.3,2.7c.4,2,.8,4,1.5,5.7.8,1.8,1.9,3.4,3.5,4.8q.3.2.6.5.4.2.7.4q1.1.6,2.3,1t2.4.6c.3.1.7.1,1,0c.4,0,.7,0,.7,0q-.1,0-.3.1-.1.1-.3.1-.1,0-.1,0t0,0l-.1.1h-.1q-.3,0-.6.1-.2,0-.5,0c-.2,0-.5.1-.7.1s-.4,0-.4,0v.1h-.1q0,.1-.1.1t-.1,0q-.1,0-.3.1-.1,0-.2.1-.1,0-.2,0-.1.1-.1.1c0,.3-.4.4-.8.5s-.7.3-.7.5-.4.3-.8.3c-.5,0-.9,0-.8.3-1,.4-1.4.7-1.9.9s-1,.4-2,.5c-1.5.1-2.4.4-3.2.4-.8.1-1.5-.1-2.7-.7q0-.1.1-.2q0-.1.1-.3c.4-1.1.7-2.2.9-3.3.2-1,.3-2,.3-3q0,0,0-.1q0,0,0,0q0-.6,0-1.1t0-1q-.1-2.3-.3-4.5t-.5-4.3q0-.2-.1-.4q0-.2,0-.4-.2-1.2-.3-2.4-.2-1.2-.4-2.4-.3-1.2-.5-2.3-.3-1.2-.4-2.4v-.1-.2c0-.4,0-.7.2-1c.1-.3.3-.6.6-1q.1-.1.2-.2t.2-.2q.3-.3.6-.6.3-.2.7-.4.2-.2.5-.3.2-.1.5-.2.1-.1.2-.1.1-.1.3-.1.1,0,.2-.1.1,0,.2,0q.1-.1.3-.1.1-.1.3-.1q0,0,0,0t0,0q1.3-.3,2.5-.5q1.3-.3,2.5-.4q1.7-.1,3.4-.1q1.6,0,3.3,0q.3,0,.6,0t.7,0q.1-.1.2-.1.2,0,.3,0t.2,0t.2.1q.1,0,.2,0q0,0,.1,0q.2,0,.4,0q.1.1.3.1.4.1.7.3.4.2.6.5.1.1.2.2.1.2.2.3Z",
    fill: "url(#eRgiJqp653L179-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1674.4,1295.6c.2.5.4,1.1.5,1.8.2.6.2,1.2.1,1.8q0,.2-.1.4q0,.3-.2.5c-.2.2-.5.4-.7.5-.3.2-.7.2-.9.4q-.3.1-.6.2t-.6.2c-1,.3-2,0-2.9-.6-.8-.5-1.5-1.4-1.8-2.2-.2-.5-.4-1.3-.3-2c0-.7.3-1.3,1.1-1.4q.2,0,.4-.1.2,0,.5,0q.4-.1.9,0q.4,0,.9.1t1,.3q.5.1,1,.2.2.1.4,0q.2,0,.4-.1c.1,0,.2-.1.4-.2.1-.1.2-.1.3-.1q.1.1.2.1q0,.1,0,.2Z",
    fill: "url(#eRgiJqp653L181-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1675,1299.6c0,.2-.1.4-.3.6-.1.2-.3.3-.5.5q0,0,0,0t-.1,0q0,0,0,0-.1.1-.1.1-.4.2-.6.3-.3.1-.7.1q0,0-.1,0q0,0-.1,0-.2,0-.4.1-.2,0-.4,0t-.4,0-.3-.1q-.4,0-.7-.2-.2-.1-.5-.4q0,0,0,0t0,0q-.4-.4-.6-.9-.2-.6-.4-1.1q0-.1,0-.2t0-.1q0-.4,0-.6.1-.3.4-.5.4-.2.8-.3.4,0,.9-.1c.6,0,1.3,0,1.9.1.6.2,1.2.5,1.6,1.1q.1.2.2.4.1.3.2.5.1.1.1.2q0,.2.1.3q0,0,0,.1q0,0,0,.1Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1685.6,1294.1q0,0,0,0t0,0q-.1.8-.3,1.6-.1.8-.2,1.6-.1.3-.1.7t-.1.7q0,0-.1,0t-.1,0-.1.1q0,0,0,.1c-.2.4-.4.7-.7,1-.3.2-.7.4-1.1.5q-.4,0-.9-.1-.4-.1-.7-.4-.2-.3-.3-.7-.2-.3-.2-.7c0-.6.1-1.2.2-1.9.2-.6.4-1.2.8-1.6q0-.1.1-.1q0,0,.1-.1.4-.2.8-.3.5-.2.9-.3c.3-.1.7-.2,1-.3.4,0,.7,0,1,.2Z",
    fill: "url(#eRgiJqp653L184-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1685,1297.5q0,.1,0,.2t0,.2t0,.2q0,0,0,.1-.1.3-.1.5q0,.3-.1.5q0,0,0,0q0,.1-.1.1-.1.3-.3.4-.3.2-.5.4-.1,0-.1,0t-.1,0q-.1.1-.2.1-.1.1-.3.1-.4.2-.9.2t-.9-.2q-.1-.1-.2-.2q0,0-.1-.2q0,0,0,0t0,0q-.1-.3-.2-.5q0-.3,0-.6.1-.3.2-.7.2-.3.4-.6c.2-.5.6-.8,1.1-1c.4-.2.9-.3,1.4-.4q.3,0,.5.1.2,0,.3.3q0,.1.1.3q0,.1,0,.2t0,.3q.1.1.1.2Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678.8,1304.9q.3.1.6.2.4,0,.7,0t.6-.1q.3,0,.6-.1.2,0,.3-.1.1,0,.3-.1q0,0,.1,0q0,0,0,.1q0,0,0,0q0,.1,0,.1.1,0,.1-.1q0,0-.1-.1q0-.1-.1-.3-.1-.1-.2-.1-.3.2-.5.3-.2,0-.4.1-.4.1-.8.1t-.8,0c-.2,0-.4,0-.7-.1-.3,0-.5-.1-.7-.2q0,.1.2.1.1.1.1.1.2.1.4.1.1.1.3.1Z",
    fill: "#ffe5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682,1304.8q0-.1,0-.1-.1,0-.1,0-.2.1-.3.1-.1.1-.3.1-.3.1-.6.1-.3.1-.6.1t-.7,0q-.3-.1-.6-.2-.2,0-.3-.1-.2,0-.4-.1q0,0-.1-.1-.2,0-.2-.1-.1,0-.1-.1q0,0-.1,0q0,0-.1.1t-.2.1q-.1.1-.3.3-.2.1-.4.3-.1.1-.1.3q0,.1,0,.3.1.1.1.1.1.1.1.2t.1.2q0,.1.1.1t.1,0t.1,0t.1,0q.1-.1.2-.1q0,0,.1,0t.1,0q.4-.1.7,0q.4,0,.7.1.4.1.7.1t.7,0q.3,0,.6-.1.3,0,.5-.3.2-.2.4-.5t.2-.6q0,0,0,0q0-.1,0-.1t0-.1q-.1,0-.1,0Z",
    fill: "url(#eRgiJqp653L187-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677,1315.3c0,0,0,.1,0,.2s0,.2,0,.2-.1.1-.2.2-.3.2-.3.3q-.2.1-.4.3-.3.1-.5.3-.4.3-.9.6t-1,.5q-.9.6-1.9,1-1,.5-2,.8-2,.8-4,1.5-2.1.7-4.2,1-.1,0-.1,0t0,0q-.1-.3-.1-.6q0-.2.1-.5.2-.2.6-.9t.8-1.7q.1-.1.1-.2.1-.2.1-.3c.5-1.1.8-2.2,1-3.3.2-1,.2-2,.3-3q0,0,0-.1q0,0,0,0q0-.6,0-1.1t0-1.1q-.1-1-.2-2.1q0-1.1-.2-2.1q0-.3,0-.6-.1-.3-.1-.6-.1-.8-.2-1.6t-.2-1.6q0-.1,0-.1t.1,0q.1-.3.3-.7.1-.3.3-.5.4,1,.6,2.2.3,1.1.5,2.2.2,1,.4,2q.2,1.1.4,2.1c.1.5.2,1.1.4,1.6s.5,1,.9,1.3q.3.3.6.5t.6.4q.8.5,1.7,1q.8.5,1.7.9.6.3,1.2.5.7.3,1.3.5.3.1.6.2.4.1.7.2.2,0,.5.1.4,0,.7.1Z",
    fill: "url(#eRgiJqp653L188-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.1,1305.3q-.1.2-.2.4-.1.3-.3.4-.1.1-.3.2-.1.1-.2.1.1,0,.1-.1.1,0,.1,0q.1-.1.2-.2q0-.1.1-.2t.2-.2q0-.1.1-.2t.1-.3q.1-.2,0-.4q0,0,0-.1t-.1-.1q0-.1-.1-.2t-.2-.1q-.1-.1-.2-.2q0-.1-.1-.1-.2-.2-.3-.5-.2-.3-.3-.5-.1-.3-.2-.5t-.2-.5q-.3-.8-.4-1.6q0-.9.1-1.7q0-.6.2-1.1.2-.6.5-1.1q0-.1.1-.2q0-.1.1-.2t.1-.2q.1,0,.2-.1q0,0,0,0t0,0t0,0t0,.1q-.3.3-.5.8-.2.4-.3.8-.1.3-.1.5-.1.2-.1.5-.2.7-.1,1.5q0,.8.2,1.5.1.3.2.7.2.3.3.6.2.4.3.7.2.3.5.6.1.1.2.1q0,.1.1.2.1,0,.1.1.1.1.1.1.1.2.1.4q0,.1-.1.3Z",
    fill: "url(#eRgiJqp653L189-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.1,1282.9q-.5-.2-1.1-.3-.6-.2-1.1-.3-.7-.1-1.3-.1-.6.1-1.3.1c.6-.6,1.3-1.3,2.1-1.8.7-.5,1.6-.9,2.4-1.2-.1-.4-.6-.8-1.1-1.1-.5-.4-1.1-.6-1.5-.8q-1.8-.7-3.7-.9-2-.2-3.9.2-1.1.2-2.1.6-1.1.3-2,.8-.6.3-1.1.7-.6.4-1.1.7t-1,.7q-.4.4-.9.7c-.3-.3-.7-.6-1.2-.8-.5-.1-1-.2-1.4-.3q-.6,0-1.1.1t-1.1.3c-.2.1-.6.2-.9.4s-.6.4-.7.7c.8-.2,1.7-.1,2.4.2s1.4.8,1.7,1.6q-.9,0-1.8.3-.9.2-1.7.7-.3.2-.6.4t-.6.5q-.2.2-.5.5c-.1.1-.3.3-.3.6.5-.2.9-.1,1.3.1.5.3.8.6,1.1,1q.3.5.5,1.1t.4,1.2.4,1.3q.2.6.4,1.2.3,1.2.5,2.3.3,1.1.6,2.3.1.8.3,1.6.2.9.3,1.7.1.4.1.8.1.4.1.8c.1.4.1.7.1,1c.1.3.1.6.1.9c0,0,.1-.1.2-.2.1,0,.2-.1.2-.1q.1-.1.2-.1.2-.1.3-.1c0,0,.1-.1.2-.1.1-.1.2-.1.2-.1q-.1-.3-.2-.7-.1-.3-.1-.6-.1-.4-.1-.7-.1-.3-.1-.6q0-.2-.1-.3q0-.1,0-.3q0-.1,0-.2-.1-.1-.1-.3-.2-1.7-.3-3.4-.1-1.8-.1-3.5q0-.3,0-.5q0-.3,0-.5q0-.1,0-.1q0-.1.1-.1q0,0,0,0t.1-.1.3-.1q.2-.1.3-.2c.1,0,.2-.1.4-.1.1-.1.2-.1.2-.2q0,0,0,0t.1-.1q0-.3-.1-.6q0-.4,0-.7-.1-.2-.1-.4t0-.4t0-.3t0-.3q0,0,0,0t0-.1q-.1-.1-.1-.2t0-.2q.9.3,1.8.4q1,.1,1.8.1c1.3,0,2.7.1,4,.2s2.6.1,3.9-.1q1-.2,2-.4.9-.2,1.9-.5.8-.2,1.6-.6t1.6-.7c.5-.1,1.2,0,1.8.3.7.2,1.3.6,1.7.8-.3-.7-.8-1.4-1.3-2s-1.2-1.1-1.9-1.5Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.1,1294.4c.1.1.4,0,.6,0c.2-.1.4-.3.5-.4q.4-.2.7-.4t.7-.3q.4-.2.9-.4.4-.1.9-.2.2,0,.3,0t.2.1.1.3q.1.2.1.3q0,.2,0,.3q0,.2-.1.4q0,.1-.1.2t-.2.2q0,.1,0,.1t-.1,0q-.1.1-.2.1-.1.1-.2.1-.1.1-.2.1-.2,0-.3.1-.1,0-.3.1-.1.1-.3.1-.5.2-1,.4t-1.1.4c-.1.1-.3.1-.5.1s-.3,0-.4-.1q-.1-.1-.1-.2-.1-.1-.1-.1-.1-.4,0-.7q0-.3.2-.6Z",
    fill: "url(#eRgiJqp653L191-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.1,1294.6c.1,0-.1.1-.3.1-.1,0-.3.1-.3.1-.2,0-.4,0-.7-.1-.2,0-.5,0-.6,0q-.5-.1-.8-.2-.4-.1-.7-.1c-.6-.1-1-.1-1.4-.2-.5,0-.9,0-1.5,0q-.2,0-.4,0t-.5,0q-.1.1-.2.2-.2.1-.3.2-.2.1-.3.2-.2.2-.3.3-.3.4-.4.8-.2.4-.1.8c0,.1.1.1.2,0s.2-.2.2-.2q.4-.2.9-.3t1-.1t1.1,0q.5,0,1.1,0c.3.1.6.1.9.2.3,0,.6,0,1,.1q.3,0,.7.1.4,0,.6,0q.3,0,.5-.1.1-.1.3-.2.1-.2.2-.3t.1-.3q.1-.2.1-.5t-.1-.5Z",
    fill: "url(#eRgiJqp653L192-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.6,1302.3q-.2.1-.5.1-.3-.1-.5-.1-.2-.1-.5-.2-.2-.1-.4-.3-.3-.3-.6-.7-.2-.4-.2-.9-.1-.2,0-.4q0-.2.1-.4.2-.3.4-.5.3-.1.5-.2.5-.2,1-.1.4.2.8.5.1.2.2.3t.2.3q0,0,.1,0q0,0,0,.1q0,0,.1.1q0,0,0,.1-.2-.2-.5-.4-.2-.1-.5-.1-.2,0-.3.1-.2.1-.3.2c-.2.3-.2.6-.2.9c0,.4.2.7.3.9q.2.3.4.4.2.2.4.3Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1677,1304.8q-.1.1-.1.1-.1.1-.2.1q0,.1-.1.1q0,0-.1.1t-.1.3q0,.1.1.3q0,.2.1.3t.2.3c0,0,0-.1-.1-.2c0-.2-.1-.3-.1-.4q-.1-.1-.1-.2t0-.2q.1-.1.1-.1.1-.1.1-.1.2-.1.3-.2t.2-.2.2-.1q0-.1.1-.1c0,0,.1-.1.1-.2.1,0,.1-.1,0,0q-.1.1-.3.2-.1.1-.3.2Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1679.4,1306.5q0,0-.1-.1-.1,0-.2-.1-.1,0-.2-.1-.1,0-.2,0-.2-.1-.4-.2-.3,0-.5,0-.1.1-.2.1q0,.1.1.2q0,.1.1.1t.2.1q.2,0,.3,0q.2,0,.4,0t.3,0q.2,0,.4,0Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675,1299.7v.1c0,.3-.1.5-.3.6-.1.2-.3.3-.5.5q0,0,0,0t0,0q-.1,0-.1.1-.1,0-.1,0-.3.2-.6.3t-.7.1q0,0-.1,0q0,.1-.1.1t-.3,0q-.1,0-.3,0q0,0-.1,0q0,0-.1,0-.2,0-.4,0t-.3,0q-.2,0-.3-.1-.1,0-.3-.1t-.4-.3-.4-.4q-.1-.1-.1-.3-.1-.1-.2-.2q0-.1-.1-.3-.1-.1-.1-.2-.1-.2-.2-.4q0-.2-.1-.4q0-.1,0-.2q0,0,0-.1q0-.3.1-.6q0-.3.3-.5.4-.1.8-.2.5-.1.9-.1c.6-.1,1.3-.1,1.9.1.6.1,1.2.5,1.6,1q.1.2.2.5.2.2.2.4.1.1.1.3.1.1.1.2q0,0,0,.1q0,0,0,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675,1299.7q-.6-.1-1.1-.3-.6-.1-1.2-.1-.3,0-.6,0-.3-.1-.6,0-.2-.1-.3-.1t-.2.1q-.5,0-1,.1-.4.1-.9.2-.1-.2-.2-.4q0-.2-.1-.4q0-.1,0-.2q0,0,0-.1q0-.3.1-.6q0-.3.3-.5.4-.1.8-.2.5-.1.9-.1c.6-.1,1.3-.1,1.9.1.6.1,1.2.5,1.6,1q.1.2.2.5.2.2.2.4.1.1.1.3.1.1.1.2q0,0,0,.1q0,0,0,0Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.8,1301.5q-.2-.2-.4-.5-.1-.3-.1-.6c0-.5.2-1,.5-1.4.3-.3.8-.5,1.3-.6.4,0,.8.1,1.2.4.3.2.5.5.7.9q0,0,0,.1q0,0,0,0q0,.4-.2.6t-.4.4h-.1l-.1.1q0,0-.1,0q0,.1-.1.1-.3.2-.5.3-.3.1-.6.1h-.2l-.2.1q-.2,0-.3,0-.2,0-.4,0Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675,1299.7q-.6-.1-1.1-.3-.6-.1-1.2-.1-.3,0-.6,0-.3-.1-.6,0q.3-.4.7-.7.3-.2.8-.2c.5-.1.9.1,1.2.3.4.2.6.5.8.9q0,0,0,.1q0,0,0,0Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.3,1300.3q0,.3.1.6.2.2.4.5q0,0,0,0q.1.1.1.1t-.1,0q0,0-.1,0q0,0,0,0t0,0q-.2-.3-.3-.6-.2-.3-.2-.6c0-.5.2-1,.5-1.4.3-.3.8-.5,1.3-.6q0,0,0,.1q0,0,0,0c-.5.1-.9.3-1.2.6-.3.4-.5.8-.5,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.4,1300.2q0,.2-.1.4q0,.1-.1.3q0,0,0,0t0,0q-.1,0-.1.1-.1,0-.1,0-.3.2-.6.3t-.7.1q-.4-.1-.6-.4t-.3-.7c0-.3.2-.6.4-.9.2-.2.5-.3.9-.4.3,0,.6.2.9.4.2.2.4.5.4.8Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.7,1364.2q0,.2.1.4q0,.2.1.4q0,.3.1.6t.2.6c0,.2.1.5.3.8.1.2.2.4.5.6.2.2.5.2.9.1.3,0,.6-.1.9-.2q.8-.3,1.6-.7.7-.4,1.5-.8q1.2-.8,2.3-1.8q1.2-.9,2.1-2.1.1-.1.2-.3t.1-.4q0-.1-.1-.3-.1-.1-.3-.2-.3-.2-.7-.2-.5,0-.8,0-.6,0-1.1,0t-1,.1q-1.3.2-2.5.5-1.3.4-2.4,1-.4.2-.7.5-.4.2-.7.5-.1.1-.3.3-.1.2-.2.4q0,0,0,.1t-.1.1Z",
    fill: "url(#eRgiJqp653L203-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.6,1361.4q-.3-.2-.7-.2-.5,0-.8,0-.9-.1-1.7,0-.8.2-1.6.4-.7.2-1.5.5-.7.3-1.3.8-1,.7-1.5,1.6-.4.9-.5,2.1-.1.4,0,.7q0,.3,0,.3-.3-.1-.5-.2-.3-.2-.7-.4c-.2-.1-.6-.8-1-1.5-.3-.7-.5-1.3-.5-1.3q0,0,0,.1t0,.1c-.3-.5-.6-1.2-.8-1.9-.2-.6-.3-1.3-.5-1.9q-.4-1.5-.9-2.9t-1.2-2.7q0,1.7.3,3.5.2,1.7.5,3.5.4,2.2.8,4.5t.8,4.6c0,.2.1.5.2.9c0,.3,0,.7-.2.8-.1.1-.4,0-.8,0s-.7-.1-.9-.1q-1.1.1-2.3.2-1.1,0-2.2.1c-1.2,0-2.4,0-3.5-.1-1.2-.1-2.3-.1-3.5-.1s-2.5.1-3.7.2c-1.3.1-2.5.2-3.8.2-1.2.1-2.3.2-3.5.3-1.1.1-2.3.1-3.5.1q-.1,0-.2,0t-.2,0q-1.8,0-3.6.1t-3.5.2q-.3,0-.5,0t-.4,0c-.3.1-.5.1-.7.1-.3.1-.5.1-.8,0q-.3-.1-.6-.3t-.6-.4c-1-.4-2-.6-3-.7-1.1,0-2.1-.1-3.1-.3q-.9-.1-1.8-.4t-1.7-.7q-.6-.2-1.1-.5-.6-.3-1.1-.7-.6-.6-1-1.5-.4-.8-.6-1.7-.2-1.1-.1-2.3q0-1.2,0-2.3q0-1.2,0-2.3.1-1.2.1-2.4c0-1.8,0-3.7,0-5.6c0-1.8.1-3.7.2-5.5.2-1.8.4-3.7.7-5.6s.8-3.7,1.5-5.4q.2-.5.4-1q.3-.5.5-.9c.9-1.4,1.9-2.6,3.1-3.7s2.5-2,3.7-3q.5-.3,1.1-.7.5-.4,1-.7.6-.5,1.2-.9t1.3-.8q.5-.3,1.1-.6.5-.3,1.1-.6q0,0,.1-.1q0,0,.1,0q.6-.3,1.2-.6.7-.3,1.3-.5.1,1,.6,1.7.5.8,1.3,1.4q0,0,0,0t.1.1q0,0,0,0t0,0q1.1.8,2.4,1.2t2.6.5q1.4.1,2.8,0q1.4-.2,2.7-.7.7-.2,1.4-.5.7-.4,1.3-.9.2-.2.4-.5.2-.2.4-.5c.1-.2.2-.5.3-.6.1-.2.2-.3.5-.4q.1,0,.2,0t.2-.1q.2,0,.4,0q.3-.1.5,0q.1,0,.3.1t.4.2c1.3.6,3.6,2,5.8,3.5c2.2,1.6,4.2,3.3,4.9,4.6q.1.4.3.7.2.4.4.7c.6,1.3,1,2.7,1.4,4.1s.7,2.8,1.1,4.2q.7,2.6,1.7,5.1q1,2.6,2.3,5c.9,1.6,2,3.1,3.2,4.4c1.1,1.4,2.4,2.7,3.7,4c.3.4.9.8,1.4,1.3.5.4.9.9.9,1.5Z",
    fill: "url(#eRgiJqp653L204-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.9,1360.4c0,1-.1,2.1-.3,3.2-.3,1.1-.6,2.2-.9,3.2q-.2.4-.4.9-.2.4-.4.8-.5.9-1,1.8t-1.1,1.7c-.4.5-.8,1-1.2,1.5-.5.4-1,.8-1.7.9-1.1.1-2.7.3-4.3.3-1.7.1-3.5.2-5,.2q-.4,0-.7,0-.4,0-.7-.1c-.8-.2-1.4-.5-2-1.1-.5-.5-1-1.1-1.3-1.8-.3-.8-.5-1.6-.7-2.5-.1-.9-.2-1.7-.2-2.6q0-.3,0-.6q0-.4,0-.7t0-.7q0-.3,0-.6q0-1.7,0-3.4q0-1.6.1-3.3c0-1.8,0-3.7,0-5.6c0-1.8.1-3.7.2-5.5.2-1.8.4-3.7.7-5.6s.8-3.7,1.5-5.4q.2-.5.4-1q.3-.5.5-.9c0,.7,0,1.4-.1,2.1c0,.8.1,1.5.2,2.3q.4,1.9,1.1,3.7t1.7,3.4c.9,1.5,1.9,2.9,3,4.1c1.1,1.3,2.3,2.4,3.7,3.5q1.3,1.1,2.6,1.9q1.3.9,2.7,1.7.5.3,1,.6t1,.6c.6.4,1,.7,1.3,1.2.2.5.3,1,.3,1.8Z",
    fill: "url(#eRgiJqp653L205-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.7,1360c.1.9.2,1.7.3,2.3.1.7.1,1.2.2,1.3q.1,1.2.3,2.4t.4,2.3c.2.8.2,1.5.4,2.3.1.8.3,1.6.6,2.2-1.1.2-2.3.2-3.4.3-1.2,0-2.3,0-3.4.1-1.2,0-2.2.1-3.3.1-1.1.1-2.3.1-3.8.1q-1.8.1-3.7.2-1.8.1-3.7.1c-1.2.1-5.4.3-9.6.5s-8.4.4-9.6.4c.8-.3,3.1-1.2,5-2.3s3.5-2.4,2.9-3.2q-.1-.2-.2-.3t-.2-.3q-.4-.7-.6-1.5t-.2-1.7c.2-.3.1-.8.1-1.2-.1-.5-.1-1-.2-1.3q0-.8-.1-1.5t-.2-1.4q-.1-1.2-.2-2.4t-.2-2.4q-.3-2.6-.6-5.2-.4-2.6-.8-5.2-.4-2.1-1.1-4.2-.6-2.1-1.6-4.1-.1-.3-.3-.7-.2-.3-.4-.7-.1-.1-.1-.2-.1-.1-.1-.2t-.1-.1q-.1-.1-.1-.2-.1-.2-.3-.3-.1-.2-.2-.4.2.2.4.4.3.1.5.4.2.1.4.4.1.2.3.4.3.4.7.9.3.5.6.9.7,1,1.4,2q.8,1.1,1.4,2.1q1.2,2,2.6,3.9t3,3.6c1.2,1.3,2.7,2.4,4.2,3.2c1.6.9,3.3,1.6,4.9,2.2c1.6.5,3.1,1,4.7,1.4c1.6.3,3.2.5,4.8.5.7.1,1.5,0,2.2,0c.8-.1,1.5-.2,2-.3.5,0,1.4-.2,2.1-.4.7-.1,1.2-.3,1.2-.3.1,0,.2.7.3,1.7.1.9.3,2.2.4,3.4Z",
    fill: "url(#eRgiJqp653L206-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.5,1322.3q-.3.6-.6,1.2t-.7,1.1q-.3.4-.6.7-.3.4-.6.7-1.2,1-2.5,1.7-1.4.6-2.9,1c-2.6.5-5.2.6-7.8.3-2.5-.3-5.1-1-7.5-2-.4-.1-.9-.3-1.4-.6-.6-.3-1.1-.7-1.6-1q.6-.5,1.2-.9t1.3-.8q.5-.3,1.1-.6.5-.3,1.1-.6q1.1.5,2.3,1t2.4,1q0,0,0,0t0,0q1.5.6,3,1q1.6.4,3.2.5q1.7.2,3.3-.3t3-1.5q.4-.3.7-.6.4-.2.8-.5.3-.3.6-.5.3-.3.6-.6.2,0,.4,0q.3-.1.5,0q.1,0,.3.1t.4.2Z",
    fill: "url(#eRgiJqp653L207-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.2,1361.3q0,0,0,0-.1.1-.1.1-.4.1-.8.3-.3.2-.7.4t-.8.5-.7.7q-.4.4-.7.9t-.5,1q-.1.6-.2,1.2q0,.5.1,1.1-.2-.1-.4-.2t-.3-.1q-.2-.1-.4-.2-.1-.1-.2-.2c-.4-.3-1.2-1-1.9-1.7s-1.4-1.4-1.4-1.5c-.1-.1-.3-1.8-.5-3.7-.2-1.8-.5-3.9-.6-4.8q-.1-.5-.2-1t-.1-.9q-.5-3.3-.9-6.6-.4-3.4-.7-6.7-.1-1.2-.1-2.5q0-1.2,0-2.4.1-.7.1-1.3.1-.6.2-1.3.1-.2.1-.5.1-.2.2-.5c0,0,.1-.2.2-.5.2-.2.3-.4.3-.5q.2.4.3.7.2.4.4.7c.1.3.1.9,0,1.5c0,.6-.1,1.2-.1,1.6q0,.8.1,1.7q0,.8.2,1.7.4,3.2,1.1,6.4.8,3.2,2.1,6.3c.7,1.8,1.7,3.5,2.8,5.1s2.3,3.1,3.5,4.5q.1.2.2.3t.2.2q.1,0,.2.1q0,.1,0,.1Z",
    fill: "url(#eRgiJqp653L208-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.3,1321.9q0,.1,0,.2q0,0,0,.1q0,0-.1.1q0,.1,0,.1-.1.3-.3.6-.1.2-.3.5-.2.4-.5.8-.2.4-.5.7-.1.1-.1.1-.1.1-.1.1-.4.4-.7.7-.4.4-.9.6-.4.3-.9.5-.4.2-.9.4-.2.1-.5.2-.2.1-.5.1-.2.1-.5.2-.2,0-.5.1-1.1.2-2.2.2t-2.2-.1q-.2-.1-.4-.1t-.4,0q-.4-.1-.9-.2-.4-.1-.8-.2c-1.2-.3-2.3-.9-3.3-1.6s-1.9-1.6-2.6-2.6c-.2-.2-.3-.3-.4-.4c0-.1-.1-.2-.2-.4-.1-.1-.1-.2-.1-.2s0,0,.1-.1q.3-.1.5-.3.3-.1.5-.3.2-.1.4-.2.2,0,.4-.1.1,0,.3.1t.4.2q.3.2.7.4.3.3.6.6.2.2.3.3.2.1.4.3.6.4,1.3.7t1.4.5q1,.3,2,.4q1.1.1,2.1-.1c.7-.1,1.5-.3,2.3-.5s1.5-.5,2.1-.9q.5-.3,1-.7.4-.3.8-.7q0-.1.1-.1q0-.1.1-.1.1-.2.1-.3.1-.1.2-.2q0-.1.1-.1q0,0,0-.1.1-.1.1-.3q0-.1-.1-.3q0,0,.2.1.1,0,.1,0q.2.1.3.1t.2.1.3.2q.2,0,.4.1q0,.1.1.1t.2.1q0,0,.1.1.1,0,.2,0q.2.1.3.2.2.1.2.3Z",
    fill: "#f05960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.8,1299.1q.1.3.2.4q0,.2,0,.2c-.1-.1-.3-.3-.5-.6-.2-.2-.5-.4-.6-.4q-.2-.1-.4-.2-.1-.2-.3-.2-.4-.1-.7-.1-.4-.1-.8,0-.4,0-.7,0-.4.1-.8.1-.4.1-.7.1-.4.1-.7.1q0-.3.1-.6q0-.3.3-.5.4-.1.8-.2.5-.1.9-.1c.6-.1,1.3-.1,1.9.1.6.1,1.2.5,1.6,1q.1.2.2.4.2.2.2.5Z",
    transform: "translate(0 0.000001)",
    fill: "url(#eRgiJqp653L210-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675,1299.7c0-.1-.1-.1-.2-.2c0,0-.1-.1-.1-.1q-.2-.2-.3-.3-.2,0-.2-.1-.2-.1-.3-.1-.1-.1-.2-.1-.4-.1-.8-.2-.3,0-.7,0-.2-.1-.5,0-.3,0-.5,0-.3,0-.6.1-.3,0-.6,0-.3.1-.6.1-.2,0-.5,0c-.3,0-.4-.2-.5-.3-.1-.2-.2-.3-.2-.5q.1.1.2.1.2,0,.3,0q.2,0,.3,0q.2,0,.4,0q.5-.1,1-.1.4,0,.9,0c.5,0,1,0,1.5.1.4.1.9.3,1.3.6q.1.1.2.2.2.1.3.2c0,.1.1.2.2.3s.2.2.2.3Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1672.6,1307.8c0,0,0,.1.2.3.1.1.3.3.6.5q.1.1.3.2.1.1.3.1c.1.1.3.1.5.1.1,0,.3,0,.5,0q-.1,0-.2.1-.2,0-.4,0-.2.1-.4.1-.2-.1-.3-.1c-.1-.1-.3-.2-.5-.3-.2-.2-.4-.5-.6-1Z",
    fill: "url(#eRgiJqp653L212-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1672.4,1299.2q0,.1,0,.2t-.1.2q-.1,0-.2,0t-.2-.1q0-.1,0-.2t.1-.2q.1,0,.2,0t.2.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685,1297.8q0,0,0,.1q0,0,0,.1t0,.2q0,.2-.1.3v.1q0,.1,0,.2t0,.2q0,0,0,.1-.1.1-.1.1q0,.2,0,.3-.1.1-.2.2-.1.2-.3.4-.2.1-.4.2-.1,0-.1.1q0,0-.1,0q0,0,0,0-.1,0-.1.1-.1,0-.2,0-.1.1-.1.1-.1,0-.1,0t0,0q-.1,0-.1,0-.1.1-.2.1t-.1,0q-.1,0-.2,0q0,.1-.1.1q0,0,0,0-.3,0-.6-.1-.3,0-.5-.1-.1-.1-.1-.2-.1,0-.1-.1-.1,0-.1-.1q0,0,0-.1-.1-.2-.2-.5q0-.2.1-.5q0-.3.1-.6t.2-.5q.1-.1.1-.2q0,0,.1-.1c.2-.4.6-.7,1.1-.9.4-.2.9-.4,1.4-.4q.3,0,.5,0q.2.1.3.3q0,.1,0,.1q0,.1,0,.1.1.1.1.2t0,.2.1.2q0,.2,0,.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685,1297.8q0,0,0,.1q0,0,0,.1t0,.2q0,.2-.1.3v.1q-.1.1-.3.1-.1,0-.3.1-.4.1-.8.1-.4.1-.8.3-.2,0-.3.1-.2.1-.4.2t-.5.2q-.2.2-.4.4-.1-.2-.2-.5q0-.2.1-.5q0-.3.1-.6t.2-.5q.5-.4,1.1-.6.5-.2,1.1-.3.3-.1.7-.2.3,0,.6,0q.1.1.1.2t0,.2.1.2q0,.2,0,.3Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.5,1300.8q-.2-.2-.3-.5t-.1-.6q0,0,0-.1t0-.1q0-.1,0-.2t.1-.1q0-.1,0-.1q0-.1,0-.1.1-.1.1-.2.1-.1.2-.2q0,0,0,0q0-.1.1-.1q0,0,.1-.1q0,0,.1,0q0-.1.1-.1q0-.1.1-.1t.2-.1q.1,0,.1,0q.1,0,.2,0t.2,0q.3-.1.6.1.4.1.6.3v.1q0,.1,0,.3t-.1.4q0,0,0,.1t-.1.2q0,0,0,.1-.1,0-.1,0-.1.1-.2.2t-.2.2q0,0-.1,0-.1.1-.1.1l-.2.1-.2.1q-.1,0-.2.1-.1,0-.1.1-.1,0-.2,0-.1.1-.2.1t-.2,0-.2.1Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.9,1298.5v.1q-.1.1-.3.1-.1,0-.3.1-.4.1-.8.1-.4.1-.8.3-.2,0-.3.1-.2.1-.4.2q0-.1.1-.2q0-.1,0-.2q0,0,0,0q0-.1.1-.1q0-.1.1-.2q0-.1.1-.2q0,0,.1-.1q0,0,0,0q.1-.1.1-.1.1-.1.1-.1.1,0,.2-.1q0,0,.1,0q.1-.1.2-.1q0,0,.1,0q.1-.1.2-.1t.2,0q.3,0,.7.1.3.2.5.4Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.9,1298.5v.1q0,0,0,0-.1-.1-.1-.1-.2-.2-.5-.3t-.6-.1q-.1,0-.2,0t-.2.1q-.1,0-.2,0-.1.1-.2.2-.2,0-.3.1t-.1.2q-.1.1-.1.1t0,.1q-.2.1-.2.3-.1.2-.1.4q0,.1,0,.3.1.1.1.3q0,.1.1.2t.2.2q0,.1,0,.1t.1.1q0,0-.1,0q0,0,0,0-.1-.1-.1-.1q0-.1-.1-.1-.1-.2-.2-.3q0-.2-.1-.4q0-.1,0-.2q0-.2,0-.3q0,0,0-.1.1,0,.1,0q0-.1,0-.1t0,0q0-.2.1-.4.2-.1.3-.3.1-.1.2-.2t.2-.1q.1-.1.2-.1t.2,0q.1-.1.2-.1t.2,0q.3,0,.7.1.3.2.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.8,1299.4q-.1.2-.2.3q0,.1-.1.2t-.2.2q-.1,0-.2.1q0,0-.1,0-.1.1-.1.1-.1,0-.1.1q0,0-.1,0q0,0,0,0-.1,0-.1.1-.1,0-.2,0-.1.1-.1.1-.1,0-.1,0t0,0q-.3-.1-.4-.4-.2-.2-.2-.5q0-.1,0-.3.1-.1.1-.2.2-.3.4-.4.3-.2.6-.2.1,0,.3,0q.2.1.3.2.1,0,.1,0q0,.1.1.1q0,.1.1.1q0,0,.1.1q0,.1,0,.1q0,.1.1.1q0,.1,0,.1t0,0Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.9,1297.4q-.2.1-.4.2t-.5.1q-.2.1-.5.2-.2,0-.5.1t-.6.2-.6.3q-.2.1-.3.2t-.2.2q0,.1-.1.1q0,.1-.1.2q0,0-.1.1t-.1.1t0-.1t0-.2q.1-.4.2-.8.2-.3.4-.6c.2-.4.6-.7,1.1-1c.4-.2.9-.3,1.4-.4q.3,0,.5.1t.3.3.1.4q0,.1,0,.3Z",
    fill: "url(#eRgiJqp653L220-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.9,1299.4q.1-.1.2-.1.1-.1.2-.2q0,0,.1-.1t.2-.1q.1-.1.3-.2t.3-.1q.5-.2,1-.3t1-.2q.2,0,.4-.1.2,0,.4-.1.1-.1.2-.2.1,0,.1-.2.1,0,.1-.1q0,0,0-.1q0,0,0-.1q0,0,0-.1q0,.1-.1.1-.2.1-.3.2-.2,0-.4.1-.1,0-.3.1t-.4.1-.3.1c-.4.1-.8.1-1.2.3-.4.1-.7.3-1,.6q-.1.1-.2.2t-.2.3q0,.1,0,.1-.1.1-.1.1Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.1,1299q0,.1,0,.2-.1.1-.1.1-.1.1-.2,0-.1,0-.2-.1q0-.1,0-.2t.1-.1q.1-.1.2-.1.1.1.2.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1661.8,1276.9c.6.1,1,.2,1.3.4.4.2.7.4,1,.7q.5.5.9,1.1.3.5.4,1.2-.1-.3-.3-.6-.3-.2-.5-.5t-.4-.5-.4-.5q-.5-.4-.9-.8-.5-.3-1.1-.5Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1664.5,1330.9c1.2.2,2.2.3,3.3.3c1.1.1,2.1,0,3.3-.2c1.1-.2,2.2-.5,3.3-.9c1-.4,2-.9,3.1-1.3c1-.5,2.1-.9,3.1-1c1-.2,2.1,0,3.1.6c1.2.7,2.1,1.4,2.8,2.3s1.1,2,1.5,3.3c.3,1.1.6,2.4.5,3.5c0,1.2-.3,2.3-1.2,3.3-.6.8-1.8,1.2-3.1,1.3-1.3.2-2.6.3-3.6.5q-1.8.3-3.6.7-1.8.5-3.5.9c-1.2.4-2.4.8-3.6.8-1.2.1-2.3-.2-3.3-1.2-.3-.5-.6-1-.8-1.5-.3-.6-.5-1.2-.7-1.7q-.3-.9-.7-1.8-.3-.8-.6-1.7c-.2-.7-.6-1.9-.8-3.1s-.1-2.4.6-2.9c.2-.1.4-.2.6-.2s.3,0,.3,0Z",
    fill: "url(#eRgiJqp653L225-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1670.6,1325.6q1.1-.1,2.2-.5q1.1-.3,2.1-.8.5-.3,1-.7.5-.3.9-.8.2-.1.4-.3.2-.1.3-.3.1-.1.2-.2.1,0,.2-.1t.2-.1q.1-.1.2-.1t.2.1q.2,0,.3.1t.2.2.1.2q.1.2.1.4t0,.4q-.2.6-.7,1.1-.4.6-.9,1c-.7.6-1.6,1-2.5,1.3-.9.4-1.8.5-2.7.6-.8.1-1.7.1-2.4-.2-.8-.2-1.5-.7-1.9-1.4q.6.1,1.2.1.7,0,1.3,0Z",
    fill: "url(#eRgiJqp653L226-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678.6,1325q-.1.1-.1.1-.1.1-.1.1-.4.4-.7.7-.4.4-.9.6-.4.3-.9.5-.4.2-.9.4-.2.1-.5.2-.2.1-.5.1-.2.1-.5.2-.2,0-.5.1-1.1.2-2.1.2-1.1,0-2.2-.1-.2,0-.5,0-.2-.1-.4-.1-.5,0-.9-.1t-.8-.2q-.7-.2-1.3-.5-.7-.3-1.3-.7-.4-.3-.8-.6t-.8-.6q-.5-.3-.9-.6t-.8-.7q-.3-.2-.5-.5-.2-.2-.5-.4-.1-.1-.2-.3-.2-.1-.2-.2t.1-.2q0-.1.1-.1.1-.1.2-.2t.2-.2q.2-.1.4-.2.1-.2.4-.3.3-.2.8-.4.4-.2.8-.4c0,.1,0,.3.1.5.1.1.2.3.2.4q.3.3.6.6.4.3.7.6q0,0,.1.1q0,.2,0,.2q0,.1.1.2q0,.1,0,.2.1.1.1.3.1.2.2.3.1.3.3.6t.4.6q.5.6,1,1t1.1.7q.5.2,1,.4.5.1,1,.3q1,.2,2,.2q1,.1,2,0q.3-.1.5-.1.3,0,.5-.1.6-.1,1.3-.3.6-.2,1.2-.5.6-.4,1.2-.8.6-.5,1.2-1Z",
    fill: "url(#eRgiJqp653L227-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.3,1297.9c0-.6.4-.9.9-1c.4-.2,1-.1,1.4.2q.2.1.4.2.1.1.3.3c0,.1.1.2.1.3c0,.2,0,.3-.2.3q-.1.1-.4.1-.2-.1-.4,0-.2,0-.4,0-.2.1-.4.1-.2.1-.4.1t-.4-.1q-.2,0-.3-.2-.2-.1-.2-.3Z",
    fill: "url(#eRgiJqp653L228-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.3,1300q-.2-.2-.5-.4-.2-.1-.5-.1c-.2,0-.4,0-.5.1-.2.1-.3.3-.4.4q-.1.3-.2.6q0,.3,0,.5c0,.2.1.4.2.6c0,.1.2.3.3.4q-.4-.1-.7-.4-.4-.3-.6-.6t-.2-.6q-.1-.4,0-.7.1-.4.3-.6.3-.3.7-.3.6-.1,1.1.1t.8.7q0,0,.1,0q0,0,0,.1q0,0,.1.1q0,0,0,.1Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1669.2,1279.2q0,.1,0,.1.1.1.1.2.2.2.3.3.2.2.4.3.4.2.7.3.4.1.8.2.2,0,.4.1.2,0,.4,0q.1-.1.2-.1.2-.1.3-.2.7-.3,1.3-.6.7-.3,1.3-.6.7-.2,1.4-.3t1.5,0q-1.2,0-2.2.5-1,.4-1.9,1.1-.1,0-.1.1-.1,0-.1.1c-.1.3.2.4.5.4.4,0,.8,0,.9,0q.4-.2.8-.3.4-.2.8-.4q1.1-.4,2.3-.8t2.4-.5q-.1,0-.2-.1-.1,0-.2,0-.1-.1-.3-.1-.1,0-.3-.1-.2,0-.5-.1-.3,0-.5-.1-.9-.1-1.9-.1-.9-.1-1.8-.1.6-.1,1.2-.2t1.2-.1q.3,0,.6,0t.6,0q.1,0,.2,0q0,0,.1,0t.2,0q0,.1.1,0q.1,0,0-.1q0,0-.1,0-.1-.1-.3-.2-.1,0-.3-.1t-.5-.1q-.3-.1-.6-.2-.3,0-.7,0-.3-.1-.6-.1-1.1-.1-2.1-.1-1,.1-2,.3-.9.2-1.8.6t-1.7.9q-.1,0-.2.1-.1,0-.1.1Z",
    fill: "url(#eRgiJqp653L231-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1674.2,1300.9q-.1,0-.1.1-.1.1-.1.1-.4.2-.7.3t-.7.1q-.4.1-.8.1-.5,0-.8-.1-.4,0-.6-.2-.3-.2-.5-.4.3.1.6.2.4,0,.5.1.5,0,1,0t1-.1q.3,0,.5,0q.3-.1.5-.1q0,0,.1,0q0-.1.1-.1Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.5,1323.8c.4,0,.7-.4,1-.7s.6-.6.9-.6.3.2.2.4c0,.2-.2.5-.2.6q-.2.3-.5.5-.3.3-.7.4c-.3.1-.5,0-.6-.1-.1-.2-.2-.3-.1-.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682,1300.8q.4,0,.7-.1.4-.1.7-.2.4-.1.7-.4.4-.2.6-.5-.1.2-.2.4t-.2.3q-.2.1-.4.2t-.3.2q-.2,0-.5.1-.2,0-.4,0t-.3,0q-.2,0-.4,0Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.8,1371.2q.1.2.2.4q0,.2.1.5c.2.4.4.9.6,1.2.3.4.6.7,1.1,1c.2.1.5.1.8.1s.6-.1.8-.1q3.5-.3,7-.4t7-.3q.6,0,1.1,0t1-.1q3.6-.1,7.3-.1q3.6-.1,7.3-.3c.4,0,.8,0,1.2,0c.5,0,.9,0,1.3-.1.6-.1,1.1-.4,1.7-.6.5-.2,1.1-.5,1.7-.5q.1,0,.2,0q0,0,.1,0c.6,0,1.1.2,1.6.3.5.2,1,.4,1.5.4q.1.1.2.1t.2,0q.2,0,.4,0t.4,0q.1,0,.2,0t.2,0q.3-.1.6-.1.4,0,.7,0q.1-.1.2-.1t.2,0t.2,0t.2,0t.3,0t.4,0q.1-.1.2-.1t.3,0q0,0-.1-.1q0,0,0,0t0,0t0,0q0-.2-.1-.3t-.2-.2q-.2-.2-.4-.4-.1-.1-.3-.3c-.8-.7-1.5-1.4-2.3-2.1s-1.6-1.3-2.5-1.9c-.3-.2-.7-.3-1-.4-.4-.1-.8,0-1.1.1q-.8.3-1.5.6t-1.4.5q-.6.3-1.3.5-.6.3-1.3.3c-.7,0-1.4,0-2.2-.2-.7-.1-1.4-.3-2.1-.5q-2.2-.6-4.5-1.2-2.2-.6-4.4-1.3c-1.4-.4-2.8-.9-4.3-1.4-1.4-.4-2.8-.9-4.3-1.2q-.9-.3-1.8-.4-.9-.2-1.9-.1-1,0-2,.2-.9.1-1.9.4-.6.2-1.2.5t-1.1.7q-.4.2-.8.5-.3.3-.6.7-.1.1-.2.2t-.2.2c-.6.7-1.1,1.6-1.4,2.5s-.4,1.9-.1,2.9Z",
    fill: "url(#eRgiJqp653L235-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.8,1371.2q.1.2.2.4q0,.2.1.5c.2.4.4.9.6,1.2.3.4.6.7,1.1,1c.2.1.5.1.8.1s.6-.1.8-.1q3.5-.3,7-.4t7-.3q.6,0,1.1,0t1-.1q3.6-.1,7.3-.1q3.6-.1,7.3-.3c.4,0,.8,0,1.2,0c.5,0,.9,0,1.3-.1.6-.1,1.1-.4,1.7-.6.5-.2,1.1-.5,1.7-.5q.1,0,.2,0q0,0,.1,0c.6,0,1.1.2,1.6.3.5.2,1,.4,1.5.4q.1.1.2.1t.2,0q.2,0,.4,0t.4,0q.1,0,.2,0t.2,0q.3-.1.6-.1.4,0,.7,0q.1-.1.2-.1t.2,0t.2,0t.2,0t.3,0t.4,0q.1-.1.2-.1t.3,0q0,0-.1-.1q0,0,0,0-.4,0-.8,0t-.9-.1c-1.3,0-2.5-.5-3.7-.8-1.2-.4-2.4-.8-3.7-.8-.8,0-1.6.2-2.4.4-.8.1-1.6.4-2.4.5q-1,.1-2.1.1t-2.1-.1q-3.4-.2-6.7-.5-3.4-.2-6.7-.6c-2.4-.2-4.7-.6-7-1.2-2.2-.5-4.4-1.4-6.4-2.7q-.4-.3-.8-.6t-.8-.5q-.1.1-.2.2t-.2.2c-.6.7-1.1,1.6-1.4,2.5s-.4,1.9-.1,2.9Z",
    fill: "url(#eRgiJqp653L236-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1685.3,1368.6v.1.2c.6-.1,1.1.1,1.6.4.6.2,1,.6,1.4.9q.7.5,1.3,1.1t1.1,1.2q.1,0,.2,0t.2,0q-.6-.7-1.3-1.3-.6-.6-1.3-1.2c-.4-.4-.9-.7-1.5-1-.5-.3-1.1-.4-1.7-.4Z",
    fill: "#e89477"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1683.9,1370.2v.1.1q.3,0,.5,0q.3,0,.6.1.2,0,.4,0q.3,0,.5.1t.5.3q.2.1.4.3.5.4.9.7.4.4.9.8.1,0,.2,0t.2,0q-.5-.5-1-.9t-1-.8q-.2-.2-.5-.3-.2-.2-.5-.3t-.5-.2q-.3,0-.5,0-.3,0-.6,0-.2,0-.5,0Z",
    fill: "#e89477"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1716.5,1370.9q0,0,0,.1-.1,0-.1,0-.2.2-.4.3t-.5.2-.6.2-.5.1q-.1,0-.1,0-.1.1-.1.1-.3,0-.6,0-.2.1-.5.1-.5.1-.9.1-.5.1-1,.2-.2,0-.4,0t-.4,0q-.3,0-.6,0t-.7-.1q-.1,0-.2,0-.2-.1-.3-.1t-.1-.1q-.1,0-.1,0-.1,0-.1,0q0-.1,0-.1-.1,0-.2,0-.1-.1-.1-.1-.2-.1-.4-.2t-.4-.2q-.2,0-.4-.1-.3-.1-.5-.2-.5-.2-1-.4-.4-.2-.9-.4-.6-.3-1.3-.6-.6-.3-1.2-.7-.3-.1-.5-.3-.3-.1-.6-.3-.4-.3-.8-.6-.4-.4-.8-.7-.2-.2-.4-.5-.2-.2-.4-.5q0-.1-.1-.2q0,0,0,0q0-.1,0-.2t0-.2q.1-.1.1-.2t.1-.3c.2-.6.5-1.1.9-1.4.3-.4.8-.7,1.3-1q.2-.1.4-.2.1-.1.3-.2c.7-.3,1.4-.5,2.2-.6.7,0,1.4,0,2.2-.1.1,0,.2,0,.4,0s.3,0,.3,0s.1.1.2.2.2.2.2.2c-.3-.2-.1-.1.3.3.3.4.9,1,1.5,1.6v.1q.2.2.4.4.1.1.3.4.6.6,1.1,1.2.5.5,1,1.1.3.4.7.8.3.4.7.7c.3.3.5.4.7.4s.4.1.7.3q.5.5,1,.8.6.4,1.1.8q0,0,0,0q.1.1.1.1Z",
    fill: "url(#eRgiJqp653L243-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1714.2,1371.9q-.3,0-.6,0-.2.1-.5.1-.5.1-.9.1-.5.1-1,.2-.2,0-.4,0t-.4,0q-.3,0-.6,0t-.7-.1q-.2,0-.4-.1-.1-.1-.3-.1-.1,0-.1,0q0-.1,0-.1-.1,0-.2,0-.1-.1-.1-.1-.2-.1-.4-.2-.2,0-.4-.1t-.5-.2q-.2-.1-.4-.2-.5-.2-1-.4-.4-.2-.9-.4-.6-.3-1.3-.6-.6-.3-1.2-.7-.3-.1-.5-.3-.3-.1-.6-.3-.4-.3-.8-.6-.5-.3-.9-.6-.2-.3-.5-.5-.2-.3-.4-.5q0-.1-.1-.2-.1,0-.1,0q0-.1.1-.2q0-.1,0-.2t.1-.2q0-.1.1-.3.3-.9.9-1.6.6-.6,1.4-1.1.3.5.6.8.3.4.6.8.7.8,1.5,1.5t1.6,1.3q.8.7,1.6,1.3.8.7,1.6,1.2t1.6.8q.8.4,1.6.7t1.5.6q.7.2,1.4.5Z",
    fill: "url(#eRgiJqp653L244-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1716.1,1370.4q-.3.2-.6.4-.3.3-.6.6c-.2.1-.4.2-.6.1-.2,0-.4-.1-.7,0q-.3,0-.6-.2-.4-.1-.6-.4t-.2-.6.2-.6q.1-.3.4-.5.2-.1.5-.3.5-.2,1-.3.5-.2,1-.3.4-.1.9-.2.4-.1.9,0c.5.1.9.3,1.3.6s.8.7,1.1,1.1q.1.1.1.2.1.2.1.3-.2,0-.3-.1-.1,0-.3-.1t-.5-.1q-.2-.1-.5-.1-.5.1-1,.2t-1,.3Z",
    fill: "url(#eRgiJqp653L246-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.1,1372.1q0,.2.1.3t.3.1q.1.1.2.1t.2,0q.4,0,.9,0t.9,0q.3,0,.7,0q.3,0,.5,0q.3,0,.6,0t.5-.1q.2,0,.3-.2t.1-.4q0-.1,0-.1q0-.1,0-.1q0-.1,0-.2t-.1-.2q-.1-.2-.3-.3t-.4-.2q-.3,0-.5-.1-.2,0-.5,0q0-.1-.1-.1q0,0-.1-.1q0,0,0,0t0,0t0,0q0-.1,0-.1q0-.1.1-.1q0-.1,0-.2t.1-.3q0-.2.1-.4.2-.2.5-.3t.6-.1c.3,0,.5.2.7.3.3.1.4.3.5.4.3.3.5.6.8.9.2.4.4.7.7,1q0,0,.1.1.1,0,.1.1.1,0,.1.1.1,0,.1,0q.1.1.1.1.1,0,.1,0q.1,0,.2,0t.1,0q.1,0,.2.1.2,0,.3,0q0,0,0,0q.1,0,.1,0q.1,0,.2,0t.2,0q.2,0,.4,0q.3,0,.5,0h.1q.4,0,.6,0q.3-.1.4-.1c.1-.2-.1-.9-.4-1.5-.3-.7-.7-1.3-.8-1.5-.3-.3-.7-.5-1-.7-.3-.1-.6-.2-.8-.3-.3-.1-1.1-.3-1.9-.5-.9-.2-1.9-.4-2.5-.3-.4.1-.9.3-1.2.6-.4.3-.8.7-1.1.9q-.5.5-.9,1.2-.4.6-.6,1.4q0,0-.1,0q0,0,0,0q0,.1,0,.2t0,.1q0,.1,0,.3q0,.1,0,.2Z",
    fill: "url(#eRgiJqp653L247-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712,1370.3q.5.2,1.1.3.5.1,1.1.1q0,0,0,0t.1,0q0,0,0,0t0,0c0-.1-.2-.2-.3-.2-.2-.1-.4-.1-.6-.1q-.2,0-.4,0t-.3,0q-.2,0-.4,0t-.3-.1Z",
    fill: "url(#eRgiJqp653L248-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.1,1372.1q0,.2.1.3t.3.1q.1.1.2.1t.2,0q.4,0,.9,0t.9,0q.3,0,.7,0q.3,0,.5,0q.3,0,.6,0t.5-.1q.2,0,.3-.2t.1-.4q0-.1,0-.1q0-.1,0-.1-.1,0-.3,0-.1,0-.3,0-.3,0-.7,0t-.8,0c-.5,0-1.3-.1-2-.2-.6-.1-1.2-.2-1.2-.2q0,.1,0,.2t0,.1q0,.1,0,.3q0,.1,0,.2Z",
    opacity: 0.6,
    fill: "url(#eRgiJqp653L249-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1718.7,1368.8c.3.5.7,1,.9,1.6.3.5.6,1.1.7,1.7h.1c-.1-.6-.3-1.2-.6-1.8s-.7-1.1-1-1.6q0,0,0,0t-.1,0q0,0,0,.1q0,0,0,0Z",
    fill: "#ea8e67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1717.3,1368.9c.3.5.6,1,.9,1.6.3.5.5,1,.7,1.6q0,0,0,0q.1,0,.1,0c-.1-.6-.4-1.1-.7-1.7-.3-.5-.6-1.1-.9-1.6q0,0-.1,0q0,0,0,0t-.1.1q0,0,.1,0Z",
    fill: "#ea8e67"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1712,1370.3c0,0,.2.1.4.1.2.1.4.1.6.1q.1,0,.2,0t.2,0q0,0,0,0q0-.1,0-.1q0-.1.1-.1q0-.1,0-.2t.1-.3q0-.2.1-.4.2-.2.5-.3t.6-.1c.3.1.5.2.7.3s.4.3.5.4c.3.3.5.6.8,1c.2.3.4.6.7.9q0,0,.1.1.1,0,.1.1.1.1.1.1.1,0,.1,0q.1.1.1.1.1,0,.1,0q.1,0,.2,0t.1,0q-.2-.3-.5-.7-.2-.3-.3-.6c-.2-.4-.5-.8-.9-1.2-.3-.5-.6-.8-.8-.9q-.4-.2-.6-.3t-.4-.2q-.3-.1-.5-.1t-.4,0q-.1,0-.2,0-.2.1-.3.2-.4.2-.8.5t-.6.8q-.1.1-.1.4-.1.2,0,.4Z",
    opacity: 0.6,
    fill: "url(#eRgiJqp653L255-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.5,1371.6q-.1-.1-.2-.3-.2-.1-.2-.3-.3-.3-.4-.5-.2-.2-.4-.5c-.1-.2-.6-.4-1.1-.5s-1,0-1.4.3q-.3.3-.3.5t0,.3q.5.1.9.2t.7.3q.2.2.3.4q0,.2,0,.4q0,.1,0,.1t0,0q0,.1.1.1t.2,0q.2,0,.4,0q.1.1.3.1c.3,0,.5,0,.7,0s.4-.1.7-.1q.2,0,.3-.1.1,0,.1,0t-.2-.1q-.1-.1-.5-.3Z",
    fill: "url(#eRgiJqp653L256-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1699.1,1367.2c0,0-.1-.2-.3-.4s-.4-.4-.6-.6q0-.1-.1-.2-.1,0-.1,0q0-.1.1-.2q0-.1,0-.2t.1-.2q0-.1.1-.3c.2-.7.6-1.4,1.2-1.8.5-.5,1.1-.9,1.8-1.2s1.4-.5,2.1-.7c.7-.1,1.4-.2,2.2-.3c0,0,.2,0,.4,0c.1.1.3.1.3.1q0,0,.1.1t.2.2.2.3q.1.1.1.1c-1.3-.1-3,.2-4.4,1-1.5.9-2.8,2.3-3.4,4.3Z",
    fill: "url(#eRgiJqp653L257-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1674.2,1371.6l16.1-2.4l16.1-2.4l13.9,1.9l14,1.8-18.5,4.9-18.5,4.8-11.5-4.3-11.6-4.3Z",
    fill: "url(#eRgiJqp653L260-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.3,1380.2l-11.5-4.3-11.6-4.3v.7l-.1.6l11.6,4.4l11.6,4.3l18.4-4.9l18.3-4.9.1-.7.2-.6-18.5,4.9-18.5,4.8Z",
    fill: "url(#eRgiJqp653L261-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1697.3,1380.2l-.2-.9-.2-1l4.2-17.4l4.2-17.4l17.5-1.7l17.5-1.8l1,.5l1,.5-22.5,19.6-22.5,19.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.3,1380.2l18.5-4.8l18.4-4.9l3.2-11.5l3.2-11.5.8-3.3.9-3.2-17.5,1.7-17.5,1.7-4.1,14.9-4.2,14.9-.8,3-.9,3Z",
    fill: "url(#eRgiJqp653L263-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.3,1380.2l18.5-4.8l18.4-4.9l3.2-11.5l3.2-11.5q-1,2.3-2.3,4.5t-2.9,4.2c-2.9,3.6-6.5,6.6-10.4,9.1-4,2.5-8.3,4.4-12.7,5.9q-3.3,1-6.6,1.7-3.3.8-6.7,1.3l-.8,3-.9,3Z",
    fill: "url(#eRgiJqp653L264-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712.7,1346.7q-.4,0-.8,0-.4.1-.8.1-.5.1-1.1.2-.5.1-.9.5-.3.3-.5.7t-.3.8c-.8,2.5-1.7,5.2-2.5,7.9s-1.6,5.4-2.3,7.9c0,.3-.2.8-.2,1.2.1.4.2.7.7.6.3-.1.6-.5.9-.9s.5-.9.6-1.2c1.2-2,2.6-4.2,4.2-6.3c1.6-2,3.4-3.9,5.2-5.3c1.5-1.2,3.1-2.1,4.8-2.9c1.6-.7,3.4-1.4,5.2-1.9q1-.3,2-.6q1-.4,1.9-.9c.7-.4.9-.9.7-1.2-.1-.3-.6-.6-1.3-.5q-3.9.5-7.8.9-3.8.4-7.7.9Z",
    fill: "url(#eRgiJqp653L265-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.3,1344.4l-1-.4-1-.5-5.1,18-5,17.9l1.1.4l1,.4l5-17.9l5-17.9Z",
    fill: "url(#eRgiJqp653L266-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.6,1357.4c-.8.8-1.3,1.7-1.4,2.6-.2.9,0,1.7.6,2.2.5.6,1.3.7,2.2.5s1.8-.7,2.6-1.5c.8-.9,1.2-1.8,1.4-2.7.1-.9,0-1.7-.6-2.2s-1.4-.7-2.2-.5c-.9.2-1.8.7-2.6,1.6Z",
    fill: "url(#eRgiJqp653L267-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.9,1357.3c-.8.9-1.3,1.8-1.4,2.7-.2.9,0,1.7.6,2.2.5.5,1.3.7,2.2.5s1.8-.7,2.6-1.6c.7-.8,1.2-1.7,1.4-2.6.1-.9-.1-1.7-.6-2.2-.6-.6-1.4-.7-2.3-.5-.8.2-1.8.7-2.5,1.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1737.1,1398.7c6.2,11,7.7,30.6,7.9,30.7-.9,8.7-24.1-20.3-21.3-24.4.9-1.4,7.3-3.9,13.4-6.3Z",
    fill: "url(#eRgiJqp653L269-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.7,1405.6c-1.8,4.5,18.8,30.6,20.9,33.4-1.7.1-5.3.2-6-.4-4.8-3.8-10.9-9.2-19.3-32.4l4.4-.6Z",
    fill: "#723530"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1754.5,1359.8l16.1-2.5l16.2-2.4l13.9,1.9l13.9,1.9-18.5,4.8-18.4,4.8-11.6-4.3-11.6-4.2Z",
    fill: "#1b9f97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.7,1368.3l-11.6-4.3-11.6-4.2v.6.7l11.5,4.3l11.6,4.4l18.4-5l18.4-4.9.1-.6.1-.6-18.5,4.8-18.4,4.8Z",
    fill: "url(#eRgiJqp653L277-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1777.7,1368.3l-.2-.9-.2-1l4.1-17.3l4.2-17.4l17.5-1.8l17.5-1.7l1.1.4l1,.5-22.5,19.6-22.5,19.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.7,1368.3l18.4-4.8l18.5-4.8l3.1-11.6l3.2-11.5.9-3.2.9-3.3-17.5,1.7-17.6,1.7-4.1,14.9-4.1,14.9-.9,3-.8,3Z",
    transform: "translate(-.942645 0.825049)",
    fill: "#1b9f97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.7,1368.3l18.4-4.8l18.5-4.8l3.1-11.6l3.2-11.5q-1,2.3-2.3,4.5t-2.9,4.2c-2.9,3.6-6.4,6.7-10.4,9.2-3.9,2.5-8.3,4.4-12.7,5.8q-3.2,1.1-6.5,1.8-3.4.7-6.7,1.2l-.9,3-.8,3Z",
    transform: "translate(-1 1)",
    fill: "url(#eRgiJqp653L280-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793,1334.8q-.4,0-.8.1-.4,0-.8.1-.5,0-1,.2-.6.1-1,.4-.3.3-.5.7-.1.4-.3.9c-.8,2.4-1.6,5.1-2.5,7.8-.8,2.7-1.6,5.4-2.2,7.9-.1.3-.2.8-.2,1.2c0,.5.1.8.6.6.4,0,.7-.4.9-.9.3-.4.5-.9.7-1.1c1.1-2.1,2.6-4.3,4.1-6.3c1.6-2.1,3.4-4,5.3-5.4c1.4-1.1,3-2,4.7-2.8s3.4-1.4,5.2-2q1-.3,2-.6q1.1-.3,2-.9c.6-.4.8-.8.7-1.2-.2-.3-.7-.5-1.4-.4q-3.9.4-7.7.8-3.9.5-7.8.9Z",
    fill: "url(#eRgiJqp653L281-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.6,1332.5l-1-.4-1-.4-5,17.9-5.1,17.9l1.1.4l1.1.4l5-17.9l4.9-17.9Z",
    fill: "url(#eRgiJqp653L282-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.9,1345.5c-.8.8-1.2,1.8-1.4,2.7-.1.8.1,1.6.6,2.2.6.5,1.4.6,2.3.4.8-.1,1.8-.7,2.5-1.5.8-.8,1.3-1.8,1.4-2.6.2-.9,0-1.7-.6-2.3-.5-.5-1.3-.6-2.2-.4s-1.8.7-2.6,1.5Z",
    fill: "url(#eRgiJqp653L283-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.2,1345.5c-.8.8-1.3,1.7-1.4,2.6-.2.9,0,1.7.6,2.2.5.6,1.4.7,2.2.5.9-.2,1.8-.7,2.6-1.5s1.3-1.8,1.4-2.7c.2-.9,0-1.7-.6-2.2-.5-.5-1.4-.7-2.2-.5-.9.2-1.8.8-2.6,1.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1771.4,1303.9c1.3,2.3,3.9,2.8,4.8,3c2.2.4,4.3-.1,4.3-.5c0-.6-5.3.2-7.6-2.8-1.7-2.2-.8-2.8-1.2-2.9-.4,0-1.6.8-.3,3.2Z",
    fill: "url(#eRgiJqp653L285-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eRgiJqp653L286",
    transform: "matrix(0 0 0 0 1889.526715 1196.666662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1978.3,1197.6q.2.2.5.3c.3.2.7.4,1,.6.4.2.7.5,1.1.6.3.2.7.3,1,.4.4.2.7.5,1.1.7q.5.2,1,.5c.3.2.7.2,1.1.4.3.2.6.4.9.5q.6.2,1.1.4c.4.1.8.2,1.2.3s.8.3,1.2.3c1,.3,2,.4,3,.6.4.1.8.2,1.2.3s.8,0,1.2.1.8,0,1.2,0c.4.1.8.1,1.2.2.9.1,1.7.3,2.5.3q.6-.1,1.2-.1c.4.1.8.2,1.3.2.3,0,.7-.1,1.1-.2.3,0,.7.1,1.1.1.3-.1.6-.2.9-.2.4,0,.9.1,1.4,0c1.4-.2,2.8-.7,4.2-1c1.1-.3,2.3-.4,3.4-.6.5-.1,1-.4,1.5-.4.5-.1,1.1-.3,1.5-.5.8-.3,1.7-.6,2.5-.9.4-.2.9-.5,1.2-.7q.4-.3.8-.4c.3-.2.4-.3.7-.5.3-.3.7-.6,1.1-.9.3-.2.6-.5.9-.8s.6-.6,1-.8.6-.6.9-.9c.7-.5,1.2-1,1.7-1.7.5-.6,1-1.1,1.3-1.8.2-.3.5-.6.7-.9.6-.7.9-1.4,1.3-2.2.2-.4.3-.7.6-1.1s.6-.9.6-1.4c.1-.5.3-1,.6-1.4q.8-1.6,1.5-3.3q1.3-3.4,2.1-6.9c1-4.5,1.1-9.2.1-13.7-.7-3.3-2.1-6.7-3.5-10-1-2.5-2.1-5.1-3.9-7.3-1.4-1.8-3.1-3.4-4.9-4.9-6.9-6.1-15.7-6.9-23.7-6.2-8.6.8-16.6,3.8-23,8.7-8.5,6.5-13.7,16.5-12.9,28q.3,4.7,1.5,9.4c.5,1.7,1.3,3.4,1.7,5.2.1.6.4,1.1.6,1.7s.5,1.2.7,1.7c.4.7.5,1.6.8,2.3.2.6.6,1.2,1,1.8s.9,1.1,1.5,1.6c.5.6,1.2,1.1,1.8,1.6.6.6,1.3,1.1,2,1.7.5.4,1,.8,1.6,1.2Z",
    transform: "matrix(.823679 0 0 0.849863 353.058126 175.411772)",
    fill: "#8693a5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6 0 0 0.7 802.780114 347.800363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1969.8,1180.4v-19h2.7l6,9.6c1.5,2.2,2.6,4.2,3.5,6.2v-.1c-.2-2.5-.3-4.8-.3-7.8v-7.9h2.3v19h-2.4l-6.1-9.7c-1.3-2.1-2.5-4.2-3.5-6.3l-.1.1c.2,2.3.2,4.6.2,7.8v8.1h-2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000.5,1173.4c0,5.1-3.5,7.3-6.7,7.3-3.7,0-6.6-2.7-6.6-7c0-4.6,3-7.3,6.8-7.3c3.9,0,6.5,2.9,6.5,7Zm-10.8.2c0,3,1.8,5.2,4.2,5.2c2.3,0,4.1-2.2,4.1-5.3c0-2.3-1.2-5.2-4.1-5.2s-4.2,2.7-4.2,5.3Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2015.4,1160.4v16.4c0,1.3,0,2.6.1,3.6h-2.2l-.1-2.4h-.1c-.7,1.5-2.4,2.7-4.6,2.7-3.3,0-5.8-2.8-5.8-6.9-.1-4.6,2.7-7.4,6.1-7.4c2,0,3.5,1,4.1,2.1v-8.1h2.5Zm-2.4,11.9c0-.3-.1-.7-.2-1-.3-1.6-1.7-2.9-3.5-2.9-2.6,0-4.1,2.2-4.1,5.2c0,2.8,1.3,5.1,4,5.1c1.7,0,3.2-1.1,3.6-3q.2-.5.2-1v-2.4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020.9,1174c0,3.4,2.2,4.7,4.6,4.7c1.8,0,2.9-.3,3.8-.7l.4,1.8c-.8.4-2.3.8-4.5.8-4.2,0-6.7-2.7-6.7-6.8s2.4-7.4,6.4-7.4c4.4,0,5.6,4,5.6,6.5c0,.5,0,.9-.1,1.1h-9.5Zm7.3-1.8c0-1.5-.7-4-3.4-4-2.5,0-3.6,2.3-3.8,4h7.2Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eRgiJqp653L293",
    transform: "matrix(0 0 0 0 1822.894515 1188.593958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1905.7,1170.3q.2.1.4.2c.3.2.6.3.9.5.2.1.4.3.7.5.3.1.6.2.9.3s.5.3.8.5q.4.2.8.4c.3.1.6.2.8.3.3.1.5.3.8.4q.4.1.8.3c.4.1.7.1,1,.2s.6.2.9.3c.7.2,1.5.3,2.3.4q.5.1.9.3c.4,0,.7,0,1,.1.3,0,.6,0,1,0c.3,0,.6.1.9.1.7.1,1.3.2,1.9.2q.5,0,1,0c.3,0,.6.1.9.1s.6-.1.9-.1.6,0,.9,0c.2,0,.4-.1.7-.1s.7,0,1.1,0c1.1-.2,2.2-.5,3.3-.8.8-.2,1.7-.3,2.6-.5.4,0,.8-.2,1.2-.3s.8-.2,1.2-.4c.6-.2,1.3-.4,1.9-.7.4-.1.7-.4,1-.6q.3-.1.5-.3c.3-.1.4-.2.6-.4q.4-.3.9-.6c.2-.2.5-.4.7-.7.3-.2.5-.4.8-.6.3-.1-.6-.4-.3-.6.5-.4.9-.9,1.3-1.4.4-.4.7-.9,1-1.4.2-.3.4-.5.6-.7.5-.5.7-1.1,1-1.7.1-.3.2-.6.4-.9.3-.3.5-.7.5-1.1.1-.4.3-.7.5-1.1q.6-1.3,1.1-2.5q1.1-2.7,1.7-5.4c.8-3.5.8-7.2.1-10.7-.6-2.6-1.7-5.2-2.7-7.8-.9-2-1.7-4-3.1-5.8-1.1-1.4-1.5-2.6-2.8-3.8-5.4-4.7-12.3-5.3-18.5-4.8-6.8.6-13,3-18,6.8-6.6,5-10.7,12.9-10.1,21.8q.3,3.8,1.2,7.4c.4,1.4,1,2.7,1.3,4.1.1.4.3.8.5,1.3.1.4.4.9.6,1.3.3.6.4,1.2.5,1.8.2.5.5,1,.8,1.4.4.4.8.9,1.2,1.3.5.4,1,.8,1.5,1.2.4.5,1,.9,1.5,1.3.4.3.8.7,1.2,1Z",
    fill: "#8693a5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6 0 0 0.65 770.017759 401.676106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915.5,1134.1h3.7v19.5c0,7.8-3.8,10.1-8.8,10.1-1.4,0-3.1-.3-4-.6l.5-3.1c.8.3,1.9.5,3.2.5c3.4,0,5.4-1.5,5.4-7.2v-19.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925,1158.7c1.7,1,4.1,1.9,6.7,1.9c3.9,0,6.1-2,6.1-5c0-2.7-1.5-4.3-5.5-5.8-4.7-1.7-7.7-4.1-7.7-8.3c0-4.5,3.8-7.9,9.5-7.9c3,0,5.1.7,6.4,1.4l-1,3.1c-1-.5-2.9-1.4-5.5-1.4-4,0-5.5,2.4-5.5,4.4c0,2.7,1.7,4.1,5.8,5.6c4.9,1.9,7.4,4.3,7.4,8.6c0,4.5-3.3,8.4-10.2,8.4-2.8,0-5.9-.8-7.5-1.9l1-3.1Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eRgiJqp653L298",
    transform: "translate(-601.985291-14)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1919,1279.6c-.3-.1-.3-.5-.1-.6c1.7-.7,3.5-.1,5.3.3q.5,0,1,0q.9.1,1.8.2c.5.1,1,.1,1.5.2c1.8-.8,4.1,0,5.2,1.7.6.5.9,1,1.3,1.7.4.9,1,1.7,1.2,2.6c1.2.5,2.1,1.4,3,2.3c1.3,1.3,2.5,2.7,3.9,4.1c1.5,1.5,3.2,2.9,4.8,4.4c1.5,1.2,3.4,2.6,4.6,4.1c1.8-1.5,3.2-3.4,4.8-5.2c1.5-1.6,3.1-3.1,4.2-4.9.1-.1.3-.2.4-.1c1.9.8,3.3,2.3,4.7,3.7c1.9,1.9,4,3.7,5.7,5.8.2.2,0,.5-.2.5q0,0-.1.1c-2.2,2-4.6,3.9-7,5.7-1.9,1.5-3.7,3.1-5.6,4.5-1.4,1-3.1,2.2-4.8,2.1-1.5,0-2.9-.9-4.1-1.7-3.5-2.5-6.6-5.7-9.6-8.7-2-2-4.1-4-5.7-6.4-1.3-1.8-2.3-3.8-3.5-5.7q-.2.1-.3-.1c-.7-.7-1.1-1.4-2-1.8-.3-.2-.6-.3-.9-.5-.6-.5-1.2-1-1.8-1.5-.5-.4-.9-1.1-.6-1.5-.5-.4-1.1-.7-1.3-1.3-.4-.9.5-1.5-.4-2.1-1.6-1.2-3.9-.5-5.4-1.9Z",
    fill: "url(#eRgiJqp653L301-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1931.5,1285.6c-1.8,0-2.3-.8-2.8-1.6-.3-.5-.6-1-1.2-1.4-.3-.2-.6-.2-.9-.2-.5,0-1.1,0-1.6-.7q-.1-.1-.1-.2.1-.2.2-.3c.5-.4,2.8-1.4,3.8-1.2.3.1.5.3.5.4.1.1.1.3-.1.4-.1.1-.3.1-.4-.1-.3-.2-2.1.4-3.1.9.2.1.5.1.8.1.4,0,.8,0,1.3.4.7.4,1,1,1.3,1.5.5.8.9,1.4,2.4,1.3q0,0,0,0c.1,0,.3.2.3.4s-.2.3-.3.3q-.1,0-.1,0Z",
    fill: "url(#eRgiJqp653L302-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1971.9,1313.6c.2,2.3.2,4.6.3,6.9c0,.1.1.2.3.3c3.7,1.1,7.7.5,11.5.8c2.2.1,4.4.2,6.6.1c1.9-.2,3.7-.6,5.5.1.2,0,.3-.1.4-.2.7-1.2.9-2.8,1.1-4.2.2-.6.6-2,.3-2.7c2-4.1-12.6-4.6-14.1-4.7-2.2-.1-4.3-.1-6.4.2-1.4.3-3.1.5-4.3,1-1.1.4-1.3,1.3-1.2,2.4Z",
    fill: "#9b574c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2001.8,1313.7c-.3-1.8-.5-3.5-.7-5.4-.2-1.3,1.6-2.3,2.6-3.1q1.5-1.3,2.9-2.7c1.3-1.3,2.9-2.7,3.2-4.6q0-.1,0-.2c-2.5-3.7-2.9-8.5-6.8-11.3-1.7-1.1-3.7-1.6-5.6-2.3-2.3-.9-4.6-1.5-7-1.8s-4.7-.6-7.1-.8c-2.5-.1-4.9.2-7.3.1-1.2,0-2.5-.1-3.7,0-1,.2-2,.5-2.9.7-1.1.3-2.1.2-3.1.6-.7.3-1.3.7-1.9,1.1-1.4.8-2.8.9-4.3,1.3-.8.2-1.9.4-2.4,1.1-.2,0-.4.1-.4.4c0,1.8.9,3.4,1.6,5c.9,2,1.8,3.9,2.8,5.7c1.1,1.9,2.4,3.6,3.6,5.4.7,1.2,1.5,2.5,2.7,3.2q.1,0,.2,0c.1,0-1.1,7.1-1.3,8.1-.2,1.8-.7,4.8.9,6.2c1.8,1.6,5.8,1.1,8.1,1.2c4.1.2,8.2-.2,12.3-.1c2.2.1,4.2.4,6.3.1c1.5-.1,3.7.4,5.1-.1c2.4-.8,2.5-5.8,2.2-7.8Z",
    fill: "#f9b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2001,1305.7c-.2,0-.3-.1-.3-.3c0-1.4-.1-2.8-.2-4.1-.1-1.4-.3-2.8-.3-4.3c0-.1.2-.3.4-.3s.3.2.3.3c0,1.4.1,2.8.2,4.2s.3,2.8.3,4.2c0,.2-.2.3-.4.3Z",
    fill: "#e58f8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2002.5,1301.6q-.1,0-.2,0c-.2-.1-.2-.3-.1-.5.6-1.4,1.1-2.9,1.5-4.1.1-.1.3-.2.4-.2.2.1.3.3.2.5-.4,1.1-.9,2.7-1.5,4.1q-.1.2-.3.2Z",
    fill: "#e58f8f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2000.3,1285.1c5.3,1.7,8.1,7.2,10.5,18l-15.4,8.2l4.9-26.2Z",
    fill: "url(#eRgiJqp653L309-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.2,1287.3c1.7,8.8,5.9,14.9,11,18.8l4.1-24.5-.4.1c-11.4,2.7-14.9,3.6-14.7,5.6Z",
    fill: "url(#eRgiJqp653L310-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1993.6,1282.9l-6.2,6.4-4.4-3.2-3.7,4.3-4.6-8.8q-1.2-.1-2.4,0c-2.3,9-4,20.3-5.4,32.6-1,5.6,1,8,5.9,7.4l23.3.2l4.2-36.7q-3.4-1.3-6.7-2.2Z",
    fill: "url(#eRgiJqp653L311-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1992.7,1418.8c-.3-3.1-.6-6.5-2.1-9.3-1.2-2.4-3.2-3.2-5.7-2.1-2.2.9-3,2.8-3.3,5-.4,1.7-.3,3.7-.3,5.2q.1.2.1.4c-.2,1.6-.3,3.1,0,4.7.5,2.3.5,5.3,1.6,7.6.2.6.4,1.1.8,1.5.7.8,2.1,1.4,3.2,1.5c1.2.2,2.2-.8,3.1-1.4.9-.7,1.8-1.4,2.2-2.5.7-1.5.3-3.2.3-4.8c0-1.9.3-3.8.1-5.8Z",
    fill: "#e0c2a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1999.3,1436.4c-.5-1.6-.9-3.4-1.8-4.9-.2-.4-.5-.9-1-1.1-.3-.1-.7,0-1.1-.1s-.9-.5-1.3-.7c-1.2-.6-2.8-1.5-4.2-1.2-1.2.2-1.7,1.5-2.1,2.5-.7,2.1-1.3,4.3-2,6.4-.7,2.2-1.5,4.1-2.5,6.2-.6,1.3-1.1,2.7-.7,4.1q0,.1,0,.3c0,0,0,.1.1.1q.3.1.6.1c.8.9,2.4,1,3.9,1q.5,0,1,.1c1.6.1,3.2-.3,4.7-.8c1.6-.6,3.4-1.6,4.7-2.9c1.1-.9,2.1-2.1,2.3-3.5.1,0,.2-.1.2-.2c0-1.8-.3-3.6-.8-5.4Z",
    fill: "#f1d6b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1987.3,1405c-.7-.2-1.5.4-2,.7-1.1.7-2.2,1.7-3.3,2.5-.1-.1-.2,0-.2.1q0,0,0,0t0,0c-.2.1-.2.4,0,.5c0,1.1,1.1,1.9,2.1,2.2c1.5.3,3-.3,3.6-1.8.4-.8,1.2-3.7-.2-4.2Z",
    fill: "url(#eRgiJqp653L315-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1996.1,1428.4c.3-1.6,1.2-2.9,2-4.3.4-.8,1.1-2.2.6-3.2-.4-.7-1.3-.7-2-.7-.8-.1-1.7-.1-2.5-.2-.4-.3-.9-.3-1.4-.3-.3-.1-.7-.1-.9.2-.3.3-.2.8-.3,1.2c0,.3,0,.6.1.9q0,.1,0,.3c-.6,2.3-1.5,4.5-1.8,6.9-.2.3.4.5.5.2c2,.4,3.6,1.6,4.2,3.6.2.8.4,1.2,1.3,1c.1,0,.3-.2.2-.3-.1-1.7-.2-3.5-.1-5.2c0,.1.1,0,.1-.1Z",
    fill: "url(#eRgiJqp653L316-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2009.5,1378.7c-.5,4.8-.8,9.6-.6,14.4.1,4.5-1,8.8-1.7,13.2-.5,3.7-1.2,7.5-2.2,11.1-.4,1.3-.7,2.5-.9,3.9-.2.9,0,2.5-.7,3.2-1.2,1.2-4.7.1-6.3,0-1.7-.2-3.6-.2-5.3-.6-1-.2-1.8-.5-2.8-.5-.4-1.4.2-3.5.3-5c.1-4.9-1.1-9.5-.6-14.3q.1-.5.1-.9c-.2.8-.6,1.5-1.1,2.1-1.3,1.9-3.1,3.5-5.2,4.2-2.4.9-3.8.4-5.1-1.8-1.1-2.1-2.2-4.1-3.7-6-1.4-1.6-2.2-3.8-3.4-5.6-1.7-2.7-3.5-5.2-4.9-8.1-2.9-6.3-2.2-13.4-1.2-20.1c1.1-8,2.5-16,3.5-24c.5-3.6.9-7.1,2-10.6s3.2-7,3.3-10.8q-.1-.4-.2-.9c-.1-.1,0-.3.1-.3c1.3-.5,2.6-.3,3.9-.1c2.1.3,4.3.2,6.4.1c4.5-.2,9-1.1,13.5-1.6.1,0,.3.1.3.2.9,2,1.2,4.1,2,6.1c2.7,4.3,6.7,7.9,8.6,12.7c1.2,3.4,1.4,7,1.5,10.5.2-.1.3,2.6.3,3.8q.2,1.4.4,2.9c.4,3.1,1.3,6.1,1.3,9.2.1,4.6-1,9.1-1.6,13.6Zm-20,15.8c.3-2.4.4-4.8.6-7.2.4-5.7-.6-11.1-2.2-16.6q-.4-1.2-.8-2.4c-.2,1.9-.5,3.7-1,5.5-.9,2.8-1.9,5.5-1.7,8.4.4,4.8,1.6,9.4,3,13.9.3,1.1.4,2.3,1.4,3c.7-.8.6-3.5.7-4.6Z",
    fill: "#f29f05",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1988.8,1403c-.2,0-.3-.1-.3-.3q-.1-.6-.1-1.1q0-.8,0-1.6c0-.1.1-.3.3-.3s.4.2.4.4q-.1.7,0,1.4q0,.6,0,1.2c0,.2-.1.3-.3.3Z",
    fill: "#c4804d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985.4,1354.9c-.2,0-.3-.1-.4-.3-.1-1.6-.6-3.6-1.1-5.5q-.3-1.1-.5-2.2-.2-.6-.2-1.3c-.1-.8-.2-1.6-.6-2.3-.2-.2-.4-.4-.6-.6-.5-.5-1-1-1-1.7c0-.2.2-.4.4-.3.2,0,.3.1.3.3c0,.4.4.8.8,1.2.2.3.5.5.6.8.5.8.6,1.7.7,2.5q.1.7.2,1.3.3,1,.5,2.1c.5,2,1,4,1.2,5.6c0,.2-.1.4-.3.4q0,0,0,0Z",
    fill: "#c4804d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.3,1338.6q-.1,0-.2-.1c-1-.7-1.8-1.6-2.7-2.4-1.1-1.1-2.3-2.2-3.6-3.1h-.1c-1.5-1.1-2.7-1.9-3.7-3.7q-.3-.4-.5-.8c-.6-.9-1.3-1.8-1.4-2.8c0-.2.2-.4.4-.4.1,0,.3.2.3.3c0,.8.7,1.7,1.2,2.5q.3.5.5.9c1,1.6,2.1,2.3,3.6,3.4l.1.1c1.4.9,2.6,2,3.7,3.1.8.8,1.7,1.6,2.6,2.4.2.1.2.3.1.5q-.1.1-.3.1Z",
    fill: "#c4804d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.9,1325.7c-.1,0-.3-.1-.3-.3s.1-.3.3-.4q2-.2,4.1-.4c2.6-.1,4.5-.1,6.2,0c.7,0,1.4,0,2.2,0c3,0,6-.4,9.1-1c.2-.1.4,0,.4.2.1.2,0,.4-.2.4-3.2.7-6.3,1.1-9.3,1.1-.8,0-1.5-.1-2.2-.1-1.7,0-3.5-.1-6.1.1q-2.1.1-4.1.4-.1,0-.1,0Z",
    fill: "#c4804d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1971.6,1335.2q0,0-.1,0c-.1-.1-.3-.2-.2-.4.2-1.5,1-3,1.8-4.4.4-.7.8-1.5,1.1-2.2.1-.2.3-.3.5-.2.1.1.2.3.1.4-.3.8-.7,1.6-1.1,2.4-.8,1.3-1.5,2.7-1.8,4.1c0,.2-.1.3-.3.3Z",
    fill: "#c4804d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977.5,1384q-.2,0-.3-.1c-.1-.1-.1-.3,0-.5.6-.6,1.3-1.1,2-1.6.8-.7,1.6-1.3,2.2-2.1c2-2.3,3.3-5.6,4-9.9.1-.1.2-.3.4-.2.2,0,.3.2.3.4-.7,4.4-2.1,7.7-4.2,10.2-.7.8-1.5,1.5-2.3,2.1-.7.5-1.3,1-1.9,1.6q-.1.1-.2.1Z",
    fill: "#c4804d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.1,1405.4q-.1,0-.1,0c-1.8-1-2.6-3.3-3.3-5.3-.2-.7-.4-1.3-.7-1.8-.6-1.4-1.4-2.7-2.1-3.9q-.4-.6-.7-1.2c-.3-.5-.8-1.1-1.4-1.8-1.1-1.3-2.4-2.8-2.4-4.3c0-.2.2-.3.3-.3.2,0,.4.1.4.3c0,1.2,1.2,2.6,2.2,3.9.6.7,1.1,1.3,1.5,1.9q.3.6.6,1.1c.8,1.3,1.6,2.6,2.2,4q.4.9.7,1.9c.7,1.9,1.4,4,3,4.9.1.1.2.3.1.4q-.1.2-.3.2Z",
    fill: "#c4804d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1996.5,1421.4q-.1,0-.2,0c-.9-.5-.5-2.8,0-5.3q.1-.4.2-.7c.2-.9.3-1.8.3-2.7.2-1.4.3-2.8.7-4.2.5-1.6.6-3.4.7-5.1c0-.7,0-1.5.1-2.3.2-2.1.1-4.2.1-6.3q0-1.3,0-2.7c0-.2.1-.3.3-.3s.3.1.3.3q0,1.4.1,2.7c0,2.1,0,4.2-.1,6.4-.1.7-.1,1.5-.2,2.2c0,1.8-.1,3.6-.6,5.3-.4,1.4-.6,2.7-.7,4.1-.1.9-.2,1.8-.4,2.8q0,.2-.1.7-.9,4.2-.4,4.5c.2.1.3.3.2.5q-.1.1-.3.1Z",
    fill: "#c4804d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2007.3,1380.2c-.2,0-.3-.1-.4-.2q-.2-.7-.3-1.4c-.7-2.2-1.3-4.3-.7-6.9q.3-1,.6-2c.3-1.1.7-2.1.8-3.2.2-1.4.2-2.6.2-4v-.1c0-.2.2-.4.3-.4q0,0,0,0c.2,0,.4.2.4.4v.1c0,1.4,0,2.7-.2,4-.2,1.2-.5,2.3-.9,3.4q-.3,1-.6,2c-.5,2.4,0,4.3.7,6.5q.2.7.4,1.4c0,.2-.1.3-.3.4q0,0,0,0Z",
    fill: "#c4804d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1992.6,1385.5c-.1,0-.3-.1-.3-.2q-.3-.8-.5-1.5c-.4-1.1-.7-2.1-1.2-3.1q-.1-.2-.2-.4c-.1-.2,0-.4.1-.5.2-.1.4,0,.5.2q.1.2.2.4c.5,1.1.9,2.2,1.2,3.2q.3.7.5,1.4c.1.2,0,.4-.2.5q0,0-.1,0Z",
    fill: "#c4804d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1987.1,1367.7c-.1,0-.3-.1-.3-.3q-.2-.5-.3-1c-.2-1-.4-2.1-.5-3.1l-.2-.6q0-.4-.1-.9c-.3-1.4-.7-3.4-.2-4.5c0-.1.2-.2.4-.1s.3.3.2.4c-.4.8,0,2.8.2,4.1q.1.5.2.8l.1.7c.2,1,.4,2.1.6,3.1q.1.4.2.9c.1.2,0,.4-.2.5q-.1,0-.1,0Z",
    fill: "#c4804d"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2012.4,1296.6c-.4-.2-.8-.2-1.2-.3q-5.2-.7-10.6-.8-2.7-.1-5.4,0c-.9,0-3.2-.2-3.7.8-.7,1.4-1.3,2.7-1.7,4.2q-3.4,11.5-6.7,23.1c-.1.4-.3.9-.1,1.2.3.8,2.4.7,3.1.7q2.5.2,5,.4q4.7.5,9.4,1.1c.9.1,1.9.2,2.8,0c1.2-.4,1.5-1.8,1.8-2.7.5-1.3.7-2.7,1.1-4.1q.5-1.4,1-2.8q1.7-5.2,3.4-10.4.8-2.6,1.6-5.2c.4-1.5,1.1-3,1-4.5-.1-.3-.4-.6-.8-.7Z",
    fill: "#424649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2008.8,1309.7q-.1,0-.1,0c-.2,0-.3-.2-.2-.4c1.3-3.6,2.5-7.3,3.6-11c0-.1.2-.2.4-.2.2.1.3.2.2.4-1.1,3.7-2.3,7.4-3.6,11c0,.2-.2.2-.3.2Z",
    fill: "#2f3335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2003.5,1326.4q-.1,0-.1,0c-.2-.1-.3-.3-.2-.4c1.1-2.5,1.9-5,2.3-7.4.4-2,1.1-4.1,1.7-6.1q.3-.7.5-1.4c0-.1.2-.2.4-.2.2.1.3.3.2.4q-.2.7-.4,1.4c-.7,2-1.4,4-1.7,6-.5,2.5-1.3,5.1-2.4,7.5c0,.2-.2.2-.3.2Z",
    fill: "#2f3335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2007.5,1304.5c-.6,0-1.2-.1-1.6-.2q-.2-.1-.4-.1c-.3,0-.7-.1-1-.5q0,0,0,0-.1-.1-.1-.4c0-.2.1-.4.1-.5l.9-2.3q.1-.3.2-.7c.1-.5.3-1.2.6-1.6.7-1,2.7-.6,3.7-.4q.2,0,.3.1.3,0,.5.3c.2.4,0,.9-.3,1.6q-.1.2-.2.3l-.8,2.7q-.1.3-.3.6c0,.3-.2.5-.4.8-.3.2-.8.3-1.2.3Zm-2.4-1.2c0,.1.1.2.5.3q.2,0,.4,0c.6.2,1.8.4,2.2.1.2-.2.3-.4.3-.5q.1-.3.2-.6l.9-2.7q0-.1.1-.4c.1-.2.4-.8.4-1q-.2,0-.3,0c-.7-.2-2.6-.5-3,.1-.3.3-.5.9-.6,1.4q-.1.4-.2.7l-.8,2.3c-.1.1-.1.2-.1.3q0,0,0,0Z",
    fill: "#2f3335",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2007,1299.6c.2-.5,1-.9,1.5-.8.3.1.5.4.5.7.1,1-1.9,1.9-2.1.8q-.1-.1,0-.3q0-.2.1-.4Z",
    fill: "#2f3335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2007.7,1302.4c-.4.5-1,.2-1-.3c0-.6,1.2-.9,1.3-.4q0,.1-.1.2q0,.3-.2.5Z",
    fill: "#2f3335"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1996.4,1319.9c.1-.2.5-.3.7-.4q-.2-.1-.4-.4-.1-.2-.1-.4c0-.3.2-.5.4-.6.7-.4,1.5-.4,2.3-.5s1.6-.3,2.5-.3q1.4-.2,2.8-.5c0,0-.4-.3-.4-.3-.3-.1-.5-.2-.8-.2q-.6-.2-1.3-.4c-.4-.2-.9-.5-1.2-.9-.5-.6.1-.9.7-1c1.3-.3,2.7.2,4,.2.5,0,1,0,1.5-.2c1.1-.6,1.6-1.9,1.8-3.2.2-1.2.5-2.6,1.4-3.4c1.3.5.5,2.3.3,3.2-.3,1,0,2.3.3,3.3.2.7.4,1.4.5,2.2c0,.5.2,1.1.1,1.5-.1.2-.2.4-.3.6-.7.9-1.5,2-2.5,2.6-1.1.6-2.4,1.3-3.7,1.3-.6,0-1.1-.2-1.7-.2s-1.1.2-1.6.4c-.8.3-1.6.6-2.4.8-.3.1-.6.2-.8.1-.3,0-.6-.2-.6-.5-.1-.7,1.4-1.2,1.9-1.5-.4,0-.8-.1-1.2-.1q-.3-.1-.5-.1-.4-.1-.7-.2-.4-.1-.7-.2c-.1-.1-.2-.1-.3-.2-.1-.2-.1-.4,0-.5Z",
    fill: "url(#eRgiJqp653L339-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1998.5,1320.1q-.9,0-1.5-.3c-.2,0-.2-.2-.2-.4.1-.2.3-.3.5-.2q.6.3,1.6.2.6,0,1.3-.2.2-.1.4-.1q1.3-.3,2.6-.4c.2,0,.3.2.3.3c0,.2-.1.4-.3.4q-1.2.1-2.4.4-.2,0-.5.1-.6.1-1.4.2-.2,0-.4,0Z",
    fill: "url(#eRgiJqp653L340-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1999.7,1321.6c-.1,0-.3-.2-.3-.3c0-.2.1-.4.3-.4q.6,0,1.1-.2.4-.1.8-.3l.8-.2c.1-.1.3,0,.4.1.1.2,0,.4-.2.5l-.7.3q-.5.1-.9.3-.6.2-1.2.2-.1,0-.1,0Z",
    fill: "url(#eRgiJqp653L341-fill)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1987.8,1281.9c.9.9,1.5,1.5,2.7.6c1.5-1.2,2.6-3.2,3.2-5c.6-1.5,1-3.4.1-4.9-.1-.2-.3-.6-.6-.9q0,0-.1-.1c-1.6-2.1-5.6-.3-6.9,1.4-2.4,3-.8,6.5,1.6,8.9Z",
    fill: "#33373a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1971.8,1276.9c.9,1.5,2.6,2.8,2.9,4.7.1.6.1,1,.4,1.6.6,1,1.1,1.7,1,2.9c0,.2.4.4.6.2.4-.7.9-1.2,1.5-1.8q.7-.6,1.3-1.5c.7-1.1,1.3-2.4,1.7-3.7.4-1.2.6-2.4.3-3.6-.3-1.7-1.4-3.1-2-4.7-.8-2-1.7-3.8-1.7-6c.1-1.6-.2-3.2-.9-4.7-.3-.7-.8-1.7-1.7-1.6-.5,0-.7.2-.7.6-.7,1.3-1.4,2.6-2.3,3.9-.7,1-1.3,2-1.8,3.1-.5,1.4-.7,3.7.6,4.9-.4,1.9-.3,4.1.8,5.7Z",
    fill: "#9b574c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980.8,1281.6c.2.4.5.9.7,1.3-1,.9-3,1.8-1,2.9c1.3.9,2.7,1,4.2.7c1.7-.4,3.3-.9,4.9-1.8.7-.5,2-1.4,2.3-2.3.4-1.5-1.4-3.4-2.2-4.5-.6-.7-1.3-1.4-1.8-2.1q0,0,.1-.1c.7-.8,1-2.2,1.9-2.9.8-.5,1.7-.5,2.1-1.3.9-1.5-.4-3.1-1.1-4.3-1.2-1.7-2-3.5-3.6-4.8-1.5-1.3-3.3-2.5-5.1-3.3-3.2-1.4-7.6-1-8.5,2.9-.4,2-.4,4.1-.3,6.2.1,1.3-.1,2.6.1,3.9.1,1,.7,1.8,1.1,2.7.9,1.7,1.7,4.2,3.4,5.3.6.4,1.3.2,1.9-.1.2.6.6,1.1.9,1.6Z",
    fill: "url(#eRgiJqp653L345-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1989.9,1280.4c.3.3-2.7,2-3.2,2.2-.9.6-1.8,1.2-2.7,1.8-.6.4-1.3.9-2,.4-.8-.7-1.1-2-1.8-2.8-.9-1.1-2.4-.1-3.5.2-.8.2-1.7.3-1.2,1.2.8,1.6,1.6,3.3,2.4,5c.3.6.6,1.9,1.4,2c.9.2,1.6-1.3,2.1-1.9.3-.4.9-1.9,1.4-2c.6-.1,1.9,1.6,2.4,2c.7.7,1.4,2.2,2.6,1.6.8-.4,1.3-1.4,1.8-2.1.8-1,1.8-1.8,2.6-2.8.5-.6,1.2-1.4,1.3-2.2.3-1.1-.8-1.3-1.7-1.6-.7-.3-1.2-.9-1.9-1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1981,1267.2q0,0,0,0q.1-.1.3-.1t.4.1.3.4q0,.2,0,.4c-.1.2-.2.5-.5.5-.3.1-.6-.1-.7-.4-.2-.3-.1-.7.2-.9Z",
    fill: "#894a3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.3,1267.4c.2-.1.5,0,.7.2q0,0,0,0c.1,0,.2.2.2.3q0,.3-.1.4c-.2.4-.7.3-.9,0-.1-.3-.2-.7.1-.9Z",
    fill: "#894a3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.8,1265.2c.5-.6,1.9-.6,2.6-.5.5.1,1.6.3,1.6,1q0,.1-.1.1c-.3,0-.5-.1-.8-.2q-.5-.1-1.1-.1c-.7,0-1.5.4-2.1.1-.2-.1-.2-.3-.1-.4Z",
    transform: "translate(.000001 0)",
    fill: "#894a3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1973.7,1265.3c.4-.1,1-.2,1.3.1.2.2.1.5-.1.6c0-.1-.2,0-.2,0q-.1,0-.2.1-.2,0-.5,0c-.2,0-.4.2-.6.3-.1,0-.2,0-.3-.1-.4-.4.2-.8.6-1Z",
    fill: "#894a3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977.9,1272.1q-.1,0-.1,0-.2,0-.4-.1c-.4,0-.9-.1-1.1-.5-.5-.5-.1-1.4.1-1.7c0-.1.3-.2.4-.1.2.1.2.3.2.4-.3.5-.3.9-.2,1c.1.2.5.2.7.3q.3,0,.5.1c.2,0,.3.2.2.4c0,.1-.2.2-.3.2Z",
    fill: "url(#eRgiJqp653L352-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977.5,1274.2c1-.3,3.6-.3,3.8-.3s.4.2.4.4c-.1.8-1.2,1.4-1.9,1.6-1.1.3-2.2-.2-2.5-1.3-.1-.1,0-.3.2-.4Z",
    fill: "#ebe0d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980.6,1280.2c-.1,0-.3-.1-.3-.3s.1-.4.3-.4q1.1-.2,2.1-.7c.4-.3.8-.5,1.6-1.1q1.3-1,2.7-2.1c.1-.2.3-.1.4,0s.1.4,0,.5q-1.3,1.1-2.7,2.1c-.8.6-1.2.9-1.7,1.1q-1.1.6-2.3.9q0,0-.1,0Z",
    fill: "url(#eRgiJqp653L354-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1973.2,1259.9q.1-.7.5-1.4c.5-1,1.3-1.5,2.2-2.2c1.3-.9,2.2-2.7,3.8-3c.8-.2,1.8-.1,2.6-.1c1,0,2.1.3,3,.7.9.3,1.6.8,2.4,1.2c1,.4,1.9.4,2.9.7c1.4.5,2.5,1.7,3.4,2.8c1.7,2.2,3.4,5,2.2,7.9c1.2,1.4,2.5,2.6,2.5,4.8q0,.9-.2,1.8c-.2,1.5-1,2.9-2.5,3.5q-.1.1-.2.2c.4,1.1-.4,1.9-1.3,2.3q0,0-.1,0q0,0,0,.1c-.6.5-1.4,1-1.7,1.7q-.1.1-.1.2-.1.4,0,.9c.1.8.7,1.5.7,2.4q.2.1.1.2c-.3.4-.8.1-1-.1q-.1,0-.1,0-.1-.1-.2-.3-.4-.3-.9-.6c-1.6-.7-3.1-1.9-2.9-3.9.2-.9.6-1.2.2-2.1-.4-.7-.5-.7-1.1-1.1-.7-.5-.9-1.1-1.1-2-.3-2.5,1.4-4.9,1.2-7.4-.1-1.4-1-2.9-2.1-3.8-1-.5-2.1-.9-3.1-1.3-.8-.4-1.5-.7-2.2-1.1s-1.3-1-2-1.3c-1.3-.6-2.6.9-3.1,1.8s-.9,1.9-1.4,2.8c-.6,1.2-.8-1.7-.8-2.1.1-.8.2-1.5.4-2.2Z",
    fill: "#9b574c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1771.5,1320.6c0,0,.1-2.6-1.6-2.7-5.9-.6-8-5.7-9.1-5c.4-.3,5.9,5.9,7.7,6c.7,0,1.2-.2,1.8.1.9.5,1.1,1.6,1.2,1.6Z",
    fill: "url(#eRgiJqp653L356-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964.6,1301.7c-3.4,3.6-6.5,7.7-10,8.9-3.9-.1-13.8-10.7-22.9-20.3c4.1,9.1,19.3,23,22.9,22.5c4-.5,8.2-4.4,12.6-8.6l-2.6-2.5Z",
    transform: "translate(.499967-.333338)",
    fill: "url(#eRgiJqp653L357-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1978.3,1257.6c.1.4,6.1.3,9.4,4.8.7,1,1.8,2.5,1.8,4.6.1,2.9-2,4.1-1.3,6.6.4,1.6,1.2,1.4,1.6,3.3.4,1.7-.2,2.5.4,4.1.5,1.2,1.4,2.1,1.5,2c.3-.1-1-1.8-.9-4.2.1-1.2.4-1.3.3-2.3-.1-1.7-1.3-2.2-1.8-3.5-.8-2.3,1.6-3.7,1.6-5.8-.1-8.4-13-11-12.6-9.6Z",
    transform: "translate(-.500033-2.666672)",
    fill: "url(#eRgiJqp653L358-fill)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademy20);
export default __webpack_public_path__ + "static/media/academy20.13ba06122eb651760d0eb77541bda799.svg";
export { ForwardRef as ReactComponent };